import { usiKeyForText } from "./usiLabelKeys";

const SIDE_OPTIONS = [
  { value: "", label: "—", labelKey: "usi.lbl.x" },
  { value: "правая", label: "правая", labelKey: "usi.lbl.pravaya" },
  { value: "левая", label: "левая", labelKey: "usi.lbl.levaya" },
];

const SIDE_BOTH_OPTIONS = [
  { value: "", label: "—", labelKey: "usi.lbl.x" },
  { value: "правая", label: "правая", labelKey: "usi.lbl.pravaya" },
  { value: "левая", label: "левая", labelKey: "usi.lbl.levaya" },
  { value: "обе", label: "обе", labelKey: "usi.lbl.obe" },
];

const ABSENT_PRESENT = [
  { value: "", label: "—", labelKey: "usi.lbl.x" },
  { value: "отсутствует", label: "отсутствует", labelKey: "usi.lbl.otsutstvuet" },
  { value: "имеется", label: "имеется", labelKey: "usi.lbl.imeetsya" },
];

const ABSENT_PLURAL = [
  { value: "", label: "—", labelKey: "usi.lbl.x" },
  { value: "отсутствуют", label: "отсутствуют", labelKey: "usi.lbl.otsutstvuyut" },
  { value: "имеются", label: "имеются", labelKey: "usi.lbl.imeyutsya" },
];

const NO_YES = [
  { value: "", label: "—", labelKey: "usi.lbl.x" },
  { value: "нет", label: "нет", labelKey: "usi.lbl.net" },
  { value: "имеется", label: "имеется", labelKey: "usi.lbl.imeetsya" },
];

const YES_NO = [
  { value: "", label: "—", labelKey: "usi.lbl.x" },
  { value: "нет", label: "нет", labelKey: "usi.lbl.net" },
  { value: "да", label: "да", labelKey: "usi.lbl.da" },
];

const note = (name, defaultValue, rows = 4) => ({
  name,
  type: "textarea",
  hideLabel: true,
  rows,
  default: defaultValue,
});

const text = (name, label, extra = {}) => ({
  name,
  label,
  labelKey: usiKeyForText(label),
  type: "text",
  ...extra,
});

const area = (name, label, extra = {}) => ({
  name,
  label,
  labelKey: usiKeyForText(label),
  type: "textarea",
  rows: extra.rows || 3,
  ...extra,
});

const sel = (name, label, options) => ({
  name,
  label,
  labelKey: usiKeyForText(label),
  type: "select",
  options,
});

const pairRows = (labelKey, items, defaults = {}) =>
  items.flatMap((item) =>
    [
      { key: "right", label: "Правая", labelKey: "usi.lbl.pravaya_2" },
      { key: "left", label: "Левая", labelKey: "usi.lbl.levaya_2" },
    ].map((side) => ({
      id: `${item.key}_${side.key}`,
      [labelKey]: item.label,
      [`${labelKey}Key`]: item.labelKey,
      side: side.label,
      sideKey: side.labelKey,
      defaults,
    })),
  );

const conclusion = (textValue) => ({
  title: "Заключение", titleKey: "usi.lbl.zaklyuchenie",
  items: [note("conclusion", textValue, 5)],
});

const duplexAortaSchema = {
  key: "duplex_aorta",
  label: "УЗИ брюшной аорты и ветвей", labelKey: "usi.lbl.uzi_bryushnoy_aorty_i_vetvey",
  title: "Дуплексное сканирование брюшной аорты и ветвей", titleKey: "usi.lbl.dupleksnoe_skanirovanie_bryushnoy_aorty_i_vetvey",
  heading: "Дуплексное сканирование брюшной аорты и ветвей", headingKey: "usi.lbl.dupleksnoe_skanirovanie_bryushnoy_aorty_i_vetvey",
  blocks: [
    {
      title: "Брюшная аорта", titleKey: "usi.lbl.bryushnaya_aorta",
      items: [
        note(
          "aorta",
          "Брюшная аорта визуализируется на доступном протяжении от диафрагмы до бифуркации.\nХод без гемодинамически значимых деформаций.\nКонтуры ровные. Стенки без выраженных структурных изменений.\nПросвет свободный, пристеночные тромботические массы не определяются.\nАтеросклеротические бляшки не выявлены.\nАневризматического расширения не выявлено.\nПри ЦДК просвет окрашивается полностью. Спектр кровотока магистрального типа.",
          7,
        ),
        text("aorta_prox_ap", "Проксимальный отдел, переднезадний диаметр, мм"),
        text("aorta_prox_tr", "Проксимальный отдел, поперечный диаметр, мм"),
        text("aorta_mid_ap", "Средний отдел, переднезадний диаметр, мм"),
        text("aorta_mid_tr", "Средний отдел, поперечный диаметр, мм"),
        text("aorta_dist_ap", "Дистальный отдел, переднезадний диаметр, мм"),
        text("aorta_dist_tr", "Дистальный отдел, поперечный диаметр, мм"),
        text("aorta_max", "Максимальный наружный диаметр, мм"),
      ],
    },
    {
      title: "Чревный ствол", titleKey: "usi.lbl.chrevnyy_stvol",
      items: [
        note(
          "celiac",
          "Чревный ствол визуализируется, проходим.\nПросвет свободный. Гемодинамически значимого локального сужения не выявлено.\nПатологического локального ускорения и постстенотической турбулентности не определяется.",
          4,
        ),
        text("celiac_psv", "PSV, см/с"),
        text("celiac_edv", "EDV, см/с"),
      ],
    },
    {
      title: "Верхняя брыжеечная артерия", titleKey: "usi.lbl.verhnyaya_bryzheechnaya_arteriya",
      items: [
        note(
          "sma",
          "Верхняя брыжеечная артерия визуализируется в доступном проксимальном отделе, проходима.\nПросвет свободный, гемодинамически значимого стенозирования не выявлено.",
          3,
        ),
        text("sma_psv", "PSV, см/с"),
        text("sma_edv", "EDV, см/с"),
      ],
    },
    {
      title: "Нижняя брыжеечная артерия", titleKey: "usi.lbl.nizhnyaya_bryzheechnaya_arteriya",
      items: [
        note(
          "ima",
          "Нижняя брыжеечная артерия визуализируется / визуализация ограничена.\nВ доступном исследованию отделе признаков гемодинамически значимого поражения не выявлено.",
          3,
        ),
      ],
    },
    {
      title: "Общие подвздошные артерии", titleKey: "usi.lbl.obschie_podvzdoshnye_arterii",
      items: [
        note(
          "iliac",
          "Общие подвздошные артерии с обеих сторон проходимы.\nПросветы свободные, гемодинамически значимых стенозов не выявлено.\nСпектр кровотока магистрального типа.",
          3,
        ),
        text("iliac_right", "Диаметр справа, мм"),
        text("iliac_left", "Диаметр слева, мм"),
      ],
    },
    {
      title: "При выявлении аневризмы / дилатации", titleKey: "usi.lbl.pri_vyyavlenii_anevrizmy_dilatacii",
      items: [
        text("aneurysm_location", "Локализация", {
          placeholder:
            "супраренальная / юкстаренальная / инфраренальная / аорто-подвздошная",
        }),
        text("aneurysm_ap", "Максимальный наружный переднезадний диаметр, мм"),
        text("aneurysm_tr", "Поперечный диаметр, мм"),
        text("aneurysm_max", "Максимальный диаметр в любой плоскости, мм"),
        text("aneurysm_length", "Протяженность расширенного сегмента, мм"),
        sel(
          "aneurysm_thrombus",
          "Пристеночные тромботические массы",
          ABSENT_PLURAL,
        ),
        text(
          "aneurysm_thrombus_mm",
          "Максимальная толщина тромботических масс, мм",
        ),
        text("aneurysm_lumen", "Свободный просвет, мм"),
        sel("aneurysm_iliac", "Вовлечение подвздошных артерий", YES_NO),
        text("aneurysm_iliac_note", "Уточнение вовлечения подвздошных артерий"),
      ],
    },
    {
      title: "При выявлении стеноза висцеральной ветви", titleKey: "usi.lbl.pri_vyyavlenii_stenoza_visceralnoy_vetvi",
      items: [
        text("visc_segment", "Артерия / сегмент"),
        text("visc_lesion", "Характер поражения"),
        text("visc_psv_before", "PSV до стеноза, см/с"),
        text("visc_psv_zone", "PSV в зоне стеноза, см/с"),
        text("visc_psv_after", "PSV дистальнее, см/с"),
        sel(
          "visc_turbulence",
          "Постстенотическая турбулентность",
          ABSENT_PRESENT,
        ),
        text("visc_significance", "Гемодинамическая значимость"),
      ],
    },
    conclusion(
      "Ультразвуковых признаков аневризматического расширения брюшной аорты не выявлено. Брюшная аорта и исследованные висцеральные ветви проходимы. Гемодинамически значимых стенозов в доступных визуализации сегментах не определяется.",
    ),
  ],
};

const duplexBcaSchema = {
  key: "duplex_bca",
  label: "УЗИ БЦА", labelKey: "usi.lbl.uzi_bca",
  title: "Дуплексное сканирование БЦА", titleKey: "usi.lbl.dupleksnoe_skanirovanie_bca",
  heading: "Дуплексное сканирование экстракраниальных отделов БЦА", headingKey: "usi.lbl.dupleksnoe_skanirovanie_ekstrakranialnyh_otdelov_bca",
  blocks: [
    {
      title: "Общие сонные артерии", titleKey: "usi.lbl.obschie_sonnye_arterii",
      items: [
        note(
          "cca",
          "Общие сонные артерии с обеих сторон проходимы, ход без гемодинамически значимых деформаций.\nДиаметры сосудов не изменены. Просветы свободные.\nКомплекс интима–медиа дифференцирован, без патологического локального утолщения.\nАтеросклеротические бляшки не выявлены.\nСпектр кровотока магистрального типа, гемодинамически значимой асимметрии не выявлено.",
          6,
        ),
        text("imt_right", "Толщина комплекса интима–медиа справа, мм"),
        text("imt_left", "Толщина комплекса интима–медиа слева, мм"),
      ],
    },
    {
      title: "Бифуркации общих сонных артерий", titleKey: "usi.lbl.bifurkacii_obschih_sonnyh_arteriy",
      items: [
        note(
          "bifurcation",
          "Бифуркации общих сонных артерий визуализируются с обеих сторон.\nПросветы свободные. Атеросклеротические бляшки не выявлены.\nГемодинамически значимых локальных изменений кровотока не определяется.",
          3,
        ),
      ],
    },
    {
      title: "Внутренние сонные артерии", titleKey: "usi.lbl.vnutrennie_sonnye_arterii",
      items: [
        note(
          "ica",
          "Внутренние сонные артерии с обеих сторон проходимы.\nХод без гемодинамически значимых деформаций.\nПросветы свободные, атеросклеротические бляшки не выявлены.\nСпектральные характеристики кровотока без признаков гемодинамически значимого стенозирования.",
          4,
        ),
      ],
    },
    {
      title: "Наружные сонные артерии", titleKey: "usi.lbl.naruzhnye_sonnye_arterii",
      items: [
        note(
          "eca",
          "Наружные сонные артерии с обеих сторон проходимы.\nПросветы свободные. Спектр кровотока типичный для наружной сонной артерии.\nГемодинамически значимых изменений не выявлено.",
          3,
        ),
      ],
    },
    {
      title: "Позвоночные артерии", titleKey: "usi.lbl.pozvonochnye_arterii",
      items: [
        note(
          "va",
          "Позвоночные артерии визуализируются в доступных исследованию сегментах с обеих сторон.\nХод в межпоперечных каналах без гемодинамически значимых деформаций.\nКровоток антеградный с обеих сторон.\nСпектр кровотока без признаков гемодинамически значимого стенозирования.\nГемодинамически значимой асимметрии кровотока не выявлено.",
          5,
        ),
        text("va_diam_right", "Диаметр справа, мм"),
        text("va_diam_left", "Диаметр слева, мм"),
      ],
    },
    {
      title: "Подключичные артерии", titleKey: "usi.lbl.podklyuchichnye_arterii",
      items: [
        note(
          "subclavian",
          "Подключичные артерии в доступных визуализации отделах проходимы.\nСпектр кровотока магистрального типа с обеих сторон.\nПризнаков гемодинамически значимого стенозирования и синдрома обкрадывания не выявлено.",
          3,
        ),
      ],
    },
    {
      type: "table",
      title: "Спектральные показатели", titleKey: "usi.lbl.spektralnye_pokazateli",
      columns: [
        { key: "artery", label: "Артерия", labelKey: "usi.lbl.arteriya", readOnly: true },
        { key: "side", label: "Сторона", labelKey: "usi.lbl.storona", readOnly: true },
        { key: "psv", label: "PSV, см/с", labelKey: "usi.lbl.psv_sm_s" },
        { key: "edv", label: "EDV, см/с", labelKey: "usi.lbl.edv_sm_s" },
        { key: "ri", label: "RI", labelKey: "usi.lbl.ri" },
      ],
      rows: pairRows("artery", [
        { key: "cca", label: "ОСА", labelKey: "usi.lbl.osa" },
        { key: "ica", label: "ВСА", labelKey: "usi.lbl.vsa" },
        { key: "eca", label: "НСА", labelKey: "usi.lbl.nsa" },
        { key: "va", label: "ПА", labelKey: "usi.lbl.pa" },
        { key: "sa", label: "Подключичная артерия", labelKey: "usi.lbl.podklyuchichnaya_arteriya" },
      ]),
    },
    {
      items: [
        text("ica_cca_ratio_right", "Отношение PSV ВСА / PSV ОСА справа"),
        text("ica_cca_ratio_left", "Отношение PSV ВСА / PSV ОСА слева"),
      ],
    },
    {
      title: "При выявлении атеросклеротической бляшки / стеноза", titleKey: "usi.lbl.pri_vyyavlenii_ateroskleroticheskoy_blyashki_stenoza",
      items: [
        text("plaque_location", "Локализация"),
        sel("plaque_side", "Сторона", SIDE_OPTIONS),
        text("plaque_length", "Протяженность бляшки, мм"),
        text("plaque_thickness", "Максимальная толщина, мм"),
        text("plaque_structure", "Структура", {
          placeholder:
            "однородная / неоднородная; гипо- / изо- / гиперэхогенная / кальцинированная",
        }),
        text("plaque_surface", "Поверхность", {
          placeholder: "ровная / неровная / изъязвленная", placeholderKey: "usi.lbl.rovnaya_nerovnaya_izyazvlennaya",
        }),
        text("plaque_stenosis", "Степень стеноза, %"),
        text("plaque_method", "Метод оценки", {
          placeholder: "NASCET / локально по диаметру / по площади", placeholderKey: "usi.lbl.nascet_lokalno_po_diametru_po_ploschadi",
        }),
        text("plaque_psv", "PSV в зоне стеноза, см/с"),
        text("plaque_edv", "EDV, см/с"),
        text("plaque_ratio", "PSV ВСА/ОСА"),
        sel(
          "plaque_post",
          "Постстенотические изменения кровотока",
          ABSENT_PLURAL,
        ),
        text("plaque_post_note", "Уточнение постстенотических изменений"),
      ],
    },
    {
      title: "При выявлении деформации", titleKey: "usi.lbl.pri_vyyavlenii_deformacii",
      items: [
        text("deform_vessel", "Артерия и сторона"),
        text("deform_type", "Тип деформации", {
          placeholder:
            "извитость / перегиб (kinking) / петлеобразование (coiling)",
        }),
        text("deform_location", "Локализация"),
        sel(
          "deform_speed",
          "Локальное изменение скоростных показателей",
          ABSENT_PRESENT,
        ),
        text("deform_speed_note", "Уточнение изменения скоростей"),
        text("deform_significance", "Гемодинамическая значимость"),
      ],
    },
    conclusion(
      "Ультразвуковых признаков атеросклеротического поражения экстракраниальных отделов брахиоцефальных артерий не выявлено. Гемодинамически значимых стенозов и деформаций не определяется. Кровоток по позвоночным артериям антеградный с обеих сторон. Спектральные характеристики кровотока по исследованным артериям без гемодинамически значимых отклонений.",
    ),
  ],
};

const duplexUpperVeinsSchema = {
  key: "duplex_upper_veins",
  label: "УЗИ вен верхних конечностей", labelKey: "usi.lbl.uzi_ven_verhnih_konechnostey",
  title: "Дуплексное сканирование вен верхних конечностей", titleKey: "usi.lbl.dupleksnoe_skanirovanie_ven_verhnih_konechnostey",
  heading: "Дуплексное сканирование вен верхних конечностей", headingKey: "usi.lbl.dupleksnoe_skanirovanie_ven_verhnih_konechnostey",
  blocks: [
    {
      title: "Центральные / проксимальные венозные сегменты", titleKey: "usi.lbl.centralnye_proksimalnye_venoznye_segmenty",
      items: [
        note(
          "central_veins",
          "Внутренние яремные вены в доступных отделах проходимы, просветы свободные.\nПодключичные вены проходимы с обеих сторон. Цветовое заполнение полное.\nСпектральный венозный кровоток фазный, с сохраненной респираторной и сердечной модуляцией.\nПризнаков тромбоза в доступных исследованию проксимальных венозных сегментах не выявлено.",
          5,
        ),
      ],
    },
    {
      title: "Глубокие вены", titleKey: "usi.lbl.glubokie_veny",
      items: [
        note(
          "deep_veins",
          "Подмышечные, плечевые, лучевые и локтевые вены с обеих сторон проходимы.\nПросветы свободные, эхогенные тромботические массы не определяются.\nВ доступных компрессии сегментах вены полностью компрессируются датчиком.\nЦветовое заполнение просветов полное. Реакция на дистальную аугментацию сохранена.\nУльтразвуковых признаков тромбоза глубоких вен не выявлено.",
          5,
        ),
      ],
    },
    {
      title: "Поверхностные вены", titleKey: "usi.lbl.poverhnostnye_veny",
      items: [
        note(
          "superficial_veins",
          "Головные и базилярные вены обеих верхних конечностей проходимы.\nПросветы свободные, тромботические массы не определяются.\nВены полностью компрессируются датчиком в доступных сегментах.\nУльтразвуковых признаков тромбоза поверхностных вен не выявлено.",
          4,
        ),
      ],
    },
    {
      type: "table",
      title: "Таблица оценки проходимости", titleKey: "usi.lbl.tablica_ocenki_prohodimosti",
      columns: [
        { key: "vein", label: "Вена", labelKey: "usi.lbl.vena", readOnly: true },
        { key: "side", label: "Сторона", labelKey: "usi.lbl.storona", readOnly: true },
        { key: "compression", label: "Компрессия", labelKey: "usi.lbl.kompressiya" },
        { key: "cdc", label: "ЦДК", labelKey: "usi.lbl.cdk" },
        { key: "thrombus", label: "Тромботические массы", labelKey: "usi.lbl.tromboticheskie_massy" },
      ],
      rows: pairRows(
        "vein",
        [
          { key: "ijv", label: "Внутренняя яремная", labelKey: "usi.lbl.vnutrennyaya_yaremnaya" },
          { key: "subclavian", label: "Подключичная", labelKey: "usi.lbl.podklyuchichnaya" },
          { key: "axillary", label: "Подмышечная", labelKey: "usi.lbl.podmyshechnaya" },
          { key: "brachial", label: "Плечевые", labelKey: "usi.lbl.plechevye" },
          { key: "radial", label: "Лучевые", labelKey: "usi.lbl.luchevye" },
          { key: "ulnar", label: "Локтевые", labelKey: "usi.lbl.loktevye" },
          { key: "cephalic", label: "Головная", labelKey: "usi.lbl.golovnaya" },
          { key: "basilic", label: "Базилярная", labelKey: "usi.lbl.bazilyarnaya" },
        ],
        { compression: "полная / н/д", cdc: "полное", thrombus: "нет" },
      ),
    },
    {
      title: "При выявлении тромбоза", titleKey: "usi.lbl.pri_vyyavlenii_tromboza",
      items: [
        text("thrombosis_segment", "Вена / сегмент"),
        sel("thrombosis_side", "Сторона", SIDE_OPTIONS),
        text("thrombosis_type", "Тромбоз", {
          placeholder: "окклюзивный / неокклюзивный", placeholderKey: "usi.lbl.okklyuzivnyy_neokklyuzivnyy",
        }),
        text("thrombosis_masses", "Тромботические массы", {
          placeholder: "гипоэхогенные / неоднородные / гиперэхогенные", placeholderKey: "usi.lbl.gipoehogennye_neodnorodnye_giperehogennye",
        }),
        text("thrombosis_compression", "Компрессия вены", {
          placeholder: "отсутствует / частичная / сохранена", placeholderKey: "usi.lbl.otsutstvuet_chastichnaya_sohranena",
        }),
        text("thrombosis_cdc", "Цветовое заполнение", {
          placeholder: "отсутствует / частичное / сохранено", placeholderKey: "usi.lbl.otsutstvuet_chastichnoe_sohraneno",
        }),
        text("thrombosis_border", "Проксимальная граница тромба"),
        sel("thrombosis_float", "Флотирующий компонент", [
          { value: "", label: "—", labelKey: "usi.lbl.x" },
          { value: "не выявлен", label: "не выявлен", labelKey: "usi.lbl.ne_vyyavlen" },
          { value: "выявлен", label: "выявлен", labelKey: "usi.lbl.vyyavlen" },
        ]),
        text("thrombosis_float_mm", "Длина флотирующего компонента, мм"),
        sel("thrombosis_recan", "Признаки реканализации", ABSENT_PLURAL),
        text(
          "thrombosis_device",
          "Катетер / порт / иное устройство и отношение тромба",
        ),
      ],
    },
    conclusion(
      "Ультразвуковых признаков тромбоза глубоких и поверхностных вен верхних конечностей не выявлено. Исследованные венозные сегменты проходимы, в доступных компрессии отделах полностью компрессируются, цветовое заполнение сохранено.",
    ),
  ],
};

const duplexLowerVeinsSchema = {
  key: "duplex_lower_veins",
  label: "УЗИ вен нижних конечностей", labelKey: "usi.lbl.uzi_ven_nizhnih_konechnostey",
  title: "Дуплексное сканирование вен нижних конечностей", titleKey: "usi.lbl.dupleksnoe_skanirovanie_ven_nizhnih_konechnostey",
  heading: "Дуплексное сканирование вен нижних конечностей", headingKey: "usi.lbl.dupleksnoe_skanirovanie_ven_nizhnih_konechnostey",
  blocks: [
    {
      title: "Глубокие вены", titleKey: "usi.lbl.glubokie_veny",
      items: [
        note(
          "deep_veins",
          "Общие бедренные, бедренные, глубокие бедренные, подколенные, задние большеберцовые и малоберцовые вены с обеих сторон проходимы.\nПросветы свободные, эхогенные тромботические массы не определяются.\nВены полностью компрессируются датчиком в доступных сегментах.\nКровоток фазный, синхронизирован с дыханием. Реакция на дистальную компрессию сохранена.\nУльтразвуковых признаков тромбоза глубоких вен не выявлено.",
          6,
        ),
      ],
    },
    {
      title: "Поверхностные вены", titleKey: "usi.lbl.poverhnostnye_veny",
      items: [
        note(
          "superficial_veins",
          "Большие и малые подкожные вены с обеих сторон проходимы, полностью компрессируются.\nПросветы свободные, тромботические массы не определяются.\nСафено-феморальные и доступные сафено-поплитеальные соустья состоятельны.\nПатологический венозный рефлюкс при функциональных пробах не зарегистрирован.",
          4,
        ),
      ],
    },
    {
      title: "Перфорантные вены", titleKey: "usi.lbl.perforantnye_veny",
      items: [
        note(
          "perforators",
          "Патологически расширенные несостоятельные перфорантные вены не выявлены.",
          2,
        ),
      ],
    },
    {
      title: "Мышечные вены голени", titleKey: "usi.lbl.myshechnye_veny_goleni",
      items: [
        note(
          "muscle_veins",
          "Икроножные и камбаловидные венозные синусы в доступных визуализации отделах проходимы, тромботические массы не выявлены.",
          2,
        ),
      ],
    },
    {
      title: "Оценка венозного рефлюкса", titleKey: "usi.lbl.ocenka_venoznogo_reflyuksa",
      items: [
        text("reflux_cfv_right", "Общая бедренная вена справа, с"),
        text("reflux_cfv_left", "Общая бедренная вена слева, с"),
        text("reflux_fv_right", "Бедренная вена справа, с"),
        text("reflux_fv_left", "Бедренная вена слева, с"),
        text("reflux_pop_right", "Подколенная вена справа, с"),
        text("reflux_pop_left", "Подколенная вена слева, с"),
        text("reflux_gsv_right", "Большая подкожная вена справа, с"),
        text("reflux_gsv_left", "Большая подкожная вена слева, с"),
        text("reflux_ssv_right", "Малая подкожная вена справа, с"),
        text("reflux_ssv_left", "Малая подкожная вена слева, с"),
        note("reflux_summary", "Патологический рефлюкс: не выявлен.", 2),
      ],
    },
    {
      type: "table",
      title: "Диаметры поверхностных вен (при оценке ХВН)", titleKey: "usi.lbl.diametry_poverhnostnyh_ven_pri_ocenke_hvn",
      columns: [
        { key: "segment", label: "Сегмент", labelKey: "usi.lbl.segment", readOnly: true },
        { key: "right", label: "Справа, мм", labelKey: "usi.lbl.sprava_mm" },
        { key: "left", label: "Слева, мм", labelKey: "usi.lbl.sleva_mm" },
      ],
      rows: [
        { id: "gsv_sfs", segment: "БПВ 1 см дистальнее СФС" },
        { id: "gsv_thigh", segment: "БПВ верхняя треть бедра" },
        { id: "gsv_knee", segment: "БПВ уровень колена" },
        { id: "ssv_prox", segment: "МПВ проксимальная голень / СПС" },
      ],
    },
    {
      title: "При выявлении тромбоза", titleKey: "usi.lbl.pri_vyyavlenii_tromboza",
      items: [
        text("thrombosis_segment", "Вена / сегмент"),
        sel("thrombosis_side", "Сторона", SIDE_OPTIONS),
        text("thrombosis_type", "Тромбоз", {
          placeholder: "окклюзивный / неокклюзивный", placeholderKey: "usi.lbl.okklyuzivnyy_neokklyuzivnyy",
        }),
        text("thrombosis_masses", "Тромботические массы", {
          placeholder:
            "гипоэхогенные / неоднородные / гиперэхогенные; фиксация",
        }),
        text("thrombosis_compression", "Компрессия вены", {
          placeholder: "отсутствует / частичная", placeholderKey: "usi.lbl.otsutstvuet_chastichnaya",
        }),
        text("thrombosis_border", "Проксимальная граница тромба"),
        sel("thrombosis_float", "Флотирующий компонент", [
          { value: "", label: "—", labelKey: "usi.lbl.x" },
          { value: "не выявлен", label: "не выявлен", labelKey: "usi.lbl.ne_vyyavlen" },
          { value: "выявлен", label: "выявлен", labelKey: "usi.lbl.vyyavlen" },
        ]),
        text("thrombosis_float_mm", "Длина флотирующего компонента, мм"),
        sel("thrombosis_recan", "Признаки реканализации", ABSENT_PLURAL),
        text("thrombosis_recan_note", "Уточнение реканализации"),
      ],
    },
    conclusion(
      "Ультразвуковых признаков тромбоза глубоких и поверхностных вен нижних конечностей не выявлено. Глубокие и поверхностные вены проходимы, компрессия сохранена. Патологический венозный рефлюкс при выполненных функциональных пробах не зарегистрирован.",
    ),
  ],
};

const duplexRenalSchema = {
  key: "duplex_renal_arteries",
  label: "УЗИ почечных артерий", labelKey: "usi.lbl.uzi_pochechnyh_arteriy",
  title: "Дуплексное сканирование почечных артерий", titleKey: "usi.lbl.dupleksnoe_skanirovanie_pochechnyh_arteriy",
  heading: "Дуплексное сканирование почечных артерий", headingKey: "usi.lbl.dupleksnoe_skanirovanie_pochechnyh_arteriy",
  blocks: [
    {
      title: "Брюшная аорта", titleKey: "usi.lbl.bryushnaya_aorta",
      items: [
        note(
          "aorta",
          "Брюшная аорта в области отхождения почечных артерий проходима.\nПросвет свободный, гемодинамически значимого поражения не выявлено.",
          3,
        ),
        text(
          "aorta_psv",
          "PSV аорты на уровне отхождения почечных артерий, см/с",
        ),
      ],
    },
    {
      title: "Правая почка", titleKey: "usi.lbl.pravaya_pochka",
      items: [
        note(
          "right_kidney",
          "Расположена типично. Контуры ровные, четкие.\nКортико-медуллярная дифференцировка сохранена.\nЧашечно-лоханочная система не расширена.",
          3,
        ),
        text("right_length", "Длина, мм"),
        text("right_width", "Ширина, мм"),
        text("right_thickness", "Толщина, мм"),
        text("right_parenchyma", "Толщина паренхимы, мм"),
      ],
    },
    {
      title: "Левая почка", titleKey: "usi.lbl.levaya_pochka",
      items: [
        note(
          "left_kidney",
          "Расположена типично. Контуры ровные, четкие.\nКортико-медуллярная дифференцировка сохранена.\nЧашечно-лоханочная система не расширена.",
          3,
        ),
        text("left_length", "Длина, мм"),
        text("left_width", "Ширина, мм"),
        text("left_thickness", "Толщина, мм"),
        text("left_parenchyma", "Толщина паренхимы, мм"),
      ],
    },
    {
      title: "Правая почечная артерия", titleKey: "usi.lbl.pravaya_pochechnaya_arteriya",
      items: [
        note(
          "right_ra",
          "Визуализируется от устья на доступном протяжении, проходима.\nЦветовое заполнение просвета полное.\nГемодинамически значимого локального ускорения кровотока не выявлено.",
          3,
        ),
        text("right_ostium_psv", "Устье: PSV, см/с"),
        text("right_ostium_edv", "Устье: EDV, см/с"),
        text("right_prox_psv", "Проксимальный сегмент: PSV, см/с"),
        text("right_prox_edv", "Проксимальный сегмент: EDV, см/с"),
        text("right_mid_psv", "Средний сегмент: PSV, см/с"),
        text("right_mid_edv", "Средний сегмент: EDV, см/с"),
        text("right_dist_psv", "Дистальный сегмент: PSV, см/с"),
        text("right_dist_edv", "Дистальный сегмент: EDV, см/с"),
        text("right_rar", "Почечно-аортальное отношение (RAR)"),
      ],
    },
    {
      title: "Левая почечная артерия", titleKey: "usi.lbl.levaya_pochechnaya_arteriya",
      items: [
        note(
          "left_ra",
          "Визуализируется от устья на доступном протяжении, проходима.\nЦветовое заполнение просвета полное.\nГемодинамически значимого локального ускорения кровотока не выявлено.",
          3,
        ),
        text("left_ostium_psv", "Устье: PSV, см/с"),
        text("left_ostium_edv", "Устье: EDV, см/с"),
        text("left_prox_psv", "Проксимальный сегмент: PSV, см/с"),
        text("left_prox_edv", "Проксимальный сегмент: EDV, см/с"),
        text("left_mid_psv", "Средний сегмент: PSV, см/с"),
        text("left_mid_edv", "Средний сегмент: EDV, см/с"),
        text("left_dist_psv", "Дистальный сегмент: PSV, см/с"),
        text("left_dist_edv", "Дистальный сегмент: EDV, см/с"),
        text("left_rar", "Почечно-аортальное отношение (RAR)"),
      ],
    },
    {
      title: "Внутрипочечный кровоток", titleKey: "usi.lbl.vnutripochechnyy_krovotok",
      items: [
        note(
          "intrarenal",
          "Внутрипочечный артериальный кровоток прослеживается до периферических отделов паренхимы с обеих сторон.\nСпектры междолевых / сегментарных артерий без признаков гемодинамически значимого проксимального препятствия.\nПризнаков tardus-parvus не выявлено.\nГемодинамически значимой асимметрии внутрипочечного кровотока не выявлено.",
          4,
        ),
        text("ri_right", "Индекс резистентности справа"),
        text("ri_left", "Индекс резистентности слева"),
        text("at_right", "Время ускорения (AT) справа, мс"),
        text("at_left", "Время ускорения (AT) слева, мс"),
      ],
    },
    {
      title: "Дополнительные почечные артерии", titleKey: "usi.lbl.dopolnitelnye_pochechnye_arterii",
      items: [
        text("accessory", "Дополнительные почечные артерии", {
          placeholder: "не визуализируются / визуализируются", placeholderKey: "usi.lbl.ne_vizualiziruyutsya_vizualiziruyutsya",
        }),
      ],
    },
    {
      type: "table",
      title: "Сводная таблица", titleKey: "usi.lbl.svodnaya_tablica",
      columns: [
        { key: "indicator", label: "Показатель", labelKey: "usi.lbl.pokazatel", readOnly: true },
        { key: "right", label: "Правая", labelKey: "usi.lbl.pravaya_2" },
        { key: "left", label: "Левая", labelKey: "usi.lbl.levaya_2" },
        { key: "aorta", label: "Аорта", labelKey: "usi.lbl.aorta" },
        { key: "comment", label: "Комментарий", labelKey: "usi.lbl.kommentariy" },
      ],
      rows: [
        {
          id: "psv_ostium",
          indicator: "PSV устье, см/с",
          defaults: { aorta: "—" },
        },
        {
          id: "psv_prox",
          indicator: "PSV проксимально, см/с",
          defaults: { aorta: "—" },
        },
        {
          id: "psv_mid",
          indicator: "PSV средний сегмент, см/с",
          defaults: { aorta: "—" },
        },
        {
          id: "psv_dist",
          indicator: "PSV дистально, см/с",
          defaults: { aorta: "—" },
        },
        { id: "rar", indicator: "RAR" },
        { id: "ri", indicator: "RI внутрипочечный", defaults: { aorta: "—" } },
        { id: "at", indicator: "AT, мс", defaults: { aorta: "—" } },
      ],
    },
    {
      title: "При выявлении стеноза", titleKey: "usi.lbl.pri_vyyavlenii_stenoza",
      items: [
        sel("stenosis_side", "Сторона", SIDE_OPTIONS),
        text("stenosis_location", "Локализация", {
          placeholder: "устье / проксимальный / средний / дистальный сегмент", placeholderKey: "usi.lbl.uste_proksimalnyy_sredniy_distalnyy_segment",
        }),
        text("stenosis_psv", "PSV в зоне максимального ускорения, см/с"),
        text("stenosis_edv", "EDV, см/с"),
        text("stenosis_rar", "RAR"),
        sel(
          "stenosis_aliasing",
          "Локальная турбулентность / aliasing",
          ABSENT_PRESENT,
        ),
        sel("stenosis_post", "Постстенотические изменения", ABSENT_PLURAL),
        sel(
          "stenosis_tardus",
          "Внутрипочечный спектр tardus-parvus",
          ABSENT_PRESENT,
        ),
        text(
          "stenosis_signs",
          "Ультразвуковые признаки гемодинамически значимого стеноза",
          {
            placeholder: "не выявлены / выявлены", placeholderKey: "usi.lbl.ne_vyyavleny_vyyavleny",
          },
        ),
      ],
    },
    conclusion(
      "Ультразвуковых признаков гемодинамически значимого стенозирования магистральных почечных артерий не выявлено. Почечные артерии проходимы на доступном исследованию протяжении. Внутрипочечный артериальный кровоток сохранен, гемодинамически значимой асимметрии не определяется.",
    ),
  ],
};

const urinaryComplexSchema = {
  key: "urinary_complex",
  label: "УЗИ мочевыделительной системы (комплексное)", labelKey: "usi.lbl.uzi_mochevydelitelnoy_sistemy_kompleksnoe",
  title: "Комплексное УЗИ мочевыделительной системы", titleKey: "usi.lbl.kompleksnoe_uzi_mochevydelitelnoy_sistemy",
  heading: "Комплексное УЗИ мочевыделительной системы", headingKey: "usi.lbl.kompleksnoe_uzi_mochevydelitelnoy_sistemy",
  headerItems: [
    {
      name: "conditions",
      label: "Условия исследования", labelKey: "usi.lbl.usloviya_issledovaniya",
      type: "textarea",
      rows: 2,
      default: "мочевой пузырь наполнен. Визуализация удовлетворительная.",
    },
  ],
  blocks: [
    {
      title: "Правая почка", titleKey: "usi.lbl.pravaya_pochka",
      items: [
        text("right_length", "Длина, мм"),
        text("right_width", "Ширина, мм"),
        text("right_thickness", "Толщина, мм"),
        text("right_parenchyma", "Толщина паренхимы в среднем сегменте, мм"),
        note(
          "right_kidney",
          "Расположена типично. Подвижность при дыхании сохранена.\nФорма обычная, бобовидная. Контуры ровные, четкие.\nРазмеры почки не изменены.\nПаренхима сохранена. Кортико-медуллярная дифференцировка сохранена.\nЭхогенность коркового вещества обычная. Эхоструктура паренхимы однородная.\nЧашечно-лоханочная система не расширена, не деформирована.\nЛоханка не расширена. Чашечки не расширены.\nКонкременты и гиперэхогенные включения с достоверной дистальной акустической тенью не определяются.\nОчаговые, объемные и кистозные образования не выявлены.\nПаранефральная клетчатка без видимых изменений.",
          8,
        ),
      ],
    },
    {
      title: "Левая почка", titleKey: "usi.lbl.levaya_pochka",
      items: [
        text("left_length", "Длина, мм"),
        text("left_width", "Ширина, мм"),
        text("left_thickness", "Толщина, мм"),
        text("left_parenchyma", "Толщина паренхимы в среднем сегменте, мм"),
        note(
          "left_kidney",
          "Расположена типично. Подвижность при дыхании сохранена.\nФорма обычная, бобовидная. Контуры ровные, четкие.\nРазмеры почки не изменены.\nПаренхима сохранена. Кортико-медуллярная дифференцировка сохранена.\nЭхогенность коркового вещества обычная. Эхоструктура паренхимы однородная.\nЧашечно-лоханочная система не расширена, не деформирована.\nЛоханка не расширена. Чашечки не расширены.\nКонкременты и гиперэхогенные включения с достоверной дистальной акустической тенью не определяются.\nОчаговые, объемные и кистозные образования не выявлены.\nПаранефральная клетчатка без видимых изменений.",
          8,
        ),
      ],
    },
    {
      title: "Мочеточники", titleKey: "usi.lbl.mochetochniki",
      items: [
        note(
          "ureters",
          "Мочеточники в доступных визуализации отделах не расширены.\nПатологических внутрипросветных включений в визуализируемых отделах не определяется.",
          3,
        ),
      ],
    },
    {
      title: "Мочевой пузырь", titleKey: "usi.lbl.mochevoy_puzyr",
      items: [
        text("bladder_volume", "Объем до мочеиспускания, мл"),
        text("bladder_wall", "Толщина стенки, мм"),
        note(
          "bladder",
          "Мочевой пузырь наполнен, расположен типично.\nФорма правильная. Контуры ровные, четкие.\nСтенки ровные, не утолщены.\nСодержимое однородное, анэхогенное.\nВнутрипросветные образования, конкременты и эхогенная взвесь не определяются.\nУстья мочеточников без видимых изменений.\nПри цветовом допплеровском картировании выбросы мочи из устьев мочеточников визуализируются с обеих сторон.",
          6,
        ),
      ],
    },
    {
      title: "Остаточная моча", titleKey: "usi.lbl.ostatochnaya_mocha",
      items: [
        text(
          "postvoid_volume",
          "Объем мочевого пузыря после мочеиспускания, мл",
        ),
        text("residual_volume", "Объем остаточной мочи, мл"),
        note(
          "residual_note",
          "Значимого объема остаточной мочи не определяется.",
          2,
        ),
      ],
    },
    {
      title: "Цветовое допплеровское картирование почек", titleKey: "usi.lbl.cvetovoe_dopplerovskoe_kartirovanie_pochek",
      items: [
        text("ri_right", "Индекс резистентности справа"),
        text("ri_left", "Индекс резистентности слева"),
        note(
          "cdc_kidneys",
          "Сосудистый рисунок обеих почек сохранен, прослеживается до периферических отделов паренхимы.\nПризнаков выраженного обеднения внутрипочечного сосудистого рисунка не выявлено.\nГемодинамически значимой асимметрии внутрипочечного кровотока не выявлено.",
          4,
        ),
      ],
    },
    {
      title: "Дополнительно", titleKey: "usi.lbl.dopolnitelno",
      items: [
        note(
          "extra",
          "Свободная жидкость в исследованных отделах не определяется.\nПатологические объемные образования в доступных визуализации отделах забрюшинного пространства не выявлены.",
          3,
        ),
      ],
    },
    conclusion(
      "Ультразвуковых признаков структурных изменений почек и мочевого пузыря на момент исследования не выявлено. Чашечно-лоханочные системы обеих почек и визуализируемые отделы мочеточников не расширены. Ультразвуковых признаков конкрементов и объемных образований не выявлено. Значимого объема остаточной мочи не определяется.",
    ),
  ],
};

const abdomenSchema = {
  key: "abdomen",
  label: "УЗИ органов брюшной полости", labelKey: "usi.lbl.uzi_organov_bryushnoy_polosti",
  title: "ОБП", titleKey: "usi.lbl.obp",
  heading: "УЗИ органов брюшной полости", headingKey: "usi.lbl.uzi_organov_bryushnoy_polosti",
  headerItems: [
    {
      name: "conditions",
      label: "Условия исследования", labelKey: "usi.lbl.usloviya_issledovaniya",
      type: "textarea",
      rows: 2,
      default:
        "исследование выполнено натощак. Визуализация органов брюшной полости удовлетворительная.",
    },
  ],
  blocks: [
    {
      title: "Печень", titleKey: "usi.lbl.pechen",
      items: [
        text("liver_right", "Правая доля, косой вертикальный размер, мм"),
        text("liver_left", "Левая доля, переднезадний размер, мм"),
        text("portal_vein", "Воротная вена, мм"),
        note(
          "liver",
          "Печень расположена обычно, не увеличена.\nКонтуры ровные, четкие. Капсула визуализируется отчетливо.\nЭхогенность паренхимы обычная.\nЭхоструктура однородная, мелкозернистая.\nЗвукопроводимость сохранена. Сосудистый рисунок не изменен.\nОчаговые и объемные образования в паренхиме печени не выявлены.\nВнутрипеченочные желчные протоки не расширены.\nВоротная вена не расширена, просвет свободный.\nПеченочные вены не расширены.\nНижняя полая вена не расширена.",
          8,
        ),
      ],
    },
    {
      title: "Желчный пузырь", titleKey: "usi.lbl.zhelchnyy_puzyr",
      items: [
        text("gb_size", "Размеры, мм"),
        text("gb_wall", "Толщина стенки, мм"),
        note(
          "gallbladder",
          "Желчный пузырь расположен обычно.\nФорма обычная, не увеличен.\nКонтуры ровные, четкие.\nСтенка не утолщена, однородная.\nСодержимое однородное, анэхогенное.\nВнутрипросветные образования, билиарный сладж и конкременты не определяются.\nОбъемные и полиповидные образования стенки не выявлены.\nПеривезикальная клетчатка не изменена.",
          6,
        ),
      ],
    },
    {
      title: "Желчные протоки", titleKey: "usi.lbl.zhelchnye_protoki",
      items: [
        text("cbd", "Общий желчный проток, мм"),
        note(
          "bile_ducts",
          "Внутрипеченочные желчные протоки не расширены.\nОбщий желчный проток не расширен.\nПросвет общего желчного протока свободный, внутрипросветные образования и конкременты не определяются.",
          3,
        ),
      ],
    },
    {
      title: "Поджелудочная железа", titleKey: "usi.lbl.podzheludochnaya_zheleza",
      items: [
        text("pancreas_head", "Головка, мм"),
        text("pancreas_body", "Тело, мм"),
        text("pancreas_tail", "Хвост, мм"),
        text("pancreas_duct", "Главный панкреатический проток, мм"),
        note(
          "pancreas",
          "Поджелудочная железа визуализируется на всем протяжении, расположена обычно.\nКонтуры ровные, четкие.\nРазмеры не увеличены.\nЭхогенность паренхимы обычная.\nЭхоструктура однородная.\nОчаговые и объемные образования не выявлены.\nГлавный панкреатический проток не расширен.\nПарапанкреатическая клетчатка без видимых изменений.",
          6,
        ),
      ],
    },
    {
      title: "Селезенка", titleKey: "usi.lbl.selezenka",
      items: [
        text("spleen_size", "Размеры, мм"),
        text("spleen_area", "Площадь максимального продольного сечения, см²"),
        text("splenic_vein", "Селезеночная вена в области ворот, мм"),
        note(
          "spleen",
          "Селезенка расположена обычно, не увеличена.\nКонтуры ровные, четкие.\nЭхогенность паренхимы обычная.\nЭхоструктура однородная.\nОчаговые и объемные образования не выявлены.\nСелезеночная вена не расширена.",
          5,
        ),
      ],
    },
    {
      title: "Брюшная аорта", titleKey: "usi.lbl.bryushnaya_aorta",
      items: [
        text("aorta_max", "Максимальный диаметр, мм"),
        note(
          "aorta",
          "Брюшная аорта визуализируется на доступном исследованию протяжении.\nДиаметр не увеличен.\nКонтуры ровные. Просвет свободный.\nАневризматического расширения не выявлено.",
          4,
        ),
      ],
    },
    {
      title: "Лимфатические узлы", titleKey: "usi.lbl.limfaticheskie_uzly",
      items: [
        note(
          "lymph",
          "В доступных визуализации отделах брюшной полости патологически измененные и увеличенные лимфатические узлы не выявлены.",
          2,
        ),
      ],
    },
    {
      title: "Свободная жидкость", titleKey: "usi.lbl.svobodnaya_zhidkost",
      items: [
        note(
          "free_fluid",
          "Свободная жидкость в брюшной полости не определяется.",
          2,
        ),
      ],
    },
    conclusion(
      "Ультразвуковых признаков структурных изменений печени, желчного пузыря, желчных протоков, поджелудочной железы и селезенки на момент исследования не выявлено.",
    ),
  ],
};

const kidneysAdrenalsSchema = {
  key: "kidneys_adrenals",
  label: "УЗИ почек и надпочечников", labelKey: "usi.lbl.uzi_pochek_i_nadpochechnikov",
  title: "почек и надпочечников норма", titleKey: "usi.lbl.pochek_i_nadpochechnikov_norma",
  heading: "УЗИ почек и надпочечников", headingKey: "usi.lbl.uzi_pochek_i_nadpochechnikov",
  headerItems: [
    {
      name: "visualization",
      label: "Качество визуализации", labelKey: "usi.lbl.kachestvo_vizualizacii",
      type: "text",
      default: "удовлетворительное",
    },
  ],
  blocks: [
    {
      title: "Правая почка", titleKey: "usi.lbl.pravaya_pochka",
      items: [
        text("right_length", "Длина, мм"),
        text("right_width", "Ширина, мм"),
        text("right_thickness", "Толщина, мм"),
        text("right_parenchyma", "Толщина паренхимы в среднем сегменте, мм"),
        note(
          "right_kidney",
          "Расположена типично. Подвижность при дыхании сохранена.\nФорма бобовидная, обычная. Контуры ровные, четкие.\nРазмеры почки не изменены.\nПаренхима сохранена. Кортико-медуллярная дифференцировка сохранена.\nЭхогенность коркового вещества обычная, не повышена.\nЭхоструктура паренхимы однородная.\nЧашечно-лоханочная система не расширена, не деформирована.\nСтенки чашечно-лоханочной системы не утолщены. Лоханка не расширена.\nМочеточник в доступных визуализации отделах не расширен.\nГиперэхогенные включения с достоверной дистальной акустической тенью не определяются. Конкременты не выявлены.\nОчаговые и объемные образования не выявлены. Кистозные образования не выявлены.\nПаранефральная клетчатка без видимых изменений. Свободная жидкость в паранефральном пространстве не определяется.",
          8,
        ),
      ],
    },
    {
      title: "Левая почка", titleKey: "usi.lbl.levaya_pochka",
      items: [
        text("left_length", "Длина, мм"),
        text("left_width", "Ширина, мм"),
        text("left_thickness", "Толщина, мм"),
        text("left_parenchyma", "Толщина паренхимы в среднем сегменте, мм"),
        note(
          "left_kidney",
          "Расположена типично. Подвижность при дыхании сохранена.\nФорма бобовидная, обычная. Контуры ровные, четкие.\nРазмеры почки не изменены.\nПаренхима сохранена. Кортико-медуллярная дифференцировка сохранена.\nЭхогенность коркового вещества обычная, не повышена.\nЭхоструктура паренхимы однородная.\nЧашечно-лоханочная система не расширена, не деформирована.\nСтенки чашечно-лоханочной системы не утолщены. Лоханка не расширена.\nМочеточник в доступных визуализации отделах не расширен.\nГиперэхогенные включения с достоверной дистальной акустической тенью не определяются. Конкременты не выявлены.\nОчаговые и объемные образования не выявлены. Кистозные образования не выявлены.\nПаранефральная клетчатка без видимых изменений. Свободная жидкость в паранефральном пространстве не определяется.",
          8,
        ),
      ],
    },
    {
      title: "Цветовое допплеровское картирование почек", titleKey: "usi.lbl.cvetovoe_dopplerovskoe_kartirovanie_pochek",
      items: [
        text("ri_right", "Индекс резистентности справа"),
        text("ri_left", "Индекс резистентности слева"),
        note(
          "cdc_kidneys",
          "При цветовом допплеровском картировании сосудистый рисунок обеих почек сохранен, прослеживается до периферических отделов паренхимы.\nПризнаков выраженного обеднения внутрипочечного сосудистого рисунка не выявлено.\nГемодинамически значимой асимметрии внутрипочечного кровотока не выявлено.",
          4,
        ),
      ],
    },
    {
      title: "Правый надпочечник", titleKey: "usi.lbl.pravyy_nadpochechnik",
      items: [
        note(
          "right_adrenal",
          "Область правого надпочечника визуализирована.\nУльтразвуковых признаков объемных образований в проекции правого надпочечника не выявлено.",
          3,
        ),
      ],
    },
    {
      title: "Левый надпочечник", titleKey: "usi.lbl.levyy_nadpochechnik",
      items: [
        note(
          "left_adrenal",
          "Область левого надпочечника визуализирована.\nУльтразвуковых признаков объемных образований в проекции левого надпочечника не выявлено.",
          3,
        ),
      ],
    },
    {
      title: "Окружающие ткани", titleKey: "usi.lbl.okruzhayuschie_tkani",
      items: [
        note(
          "surrounding",
          "Паранефральная клетчатка с обеих сторон без видимых патологических изменений.\nДополнительные жидкостные и объемные образования в исследованных отделах забрюшинного пространства не выявлены.",
          3,
        ),
      ],
    },
    conclusion(
      "Ультразвуковых признаков структурных изменений почек на момент исследования не выявлено. Чашечно-лоханочные системы обеих почек не расширены. Ультразвуковых признаков конкрементов и объемных образований почек не выявлено. Объемные образования в проекции надпочечников не определяются.",
    ),
  ],
};

const trusProstateSchema = {
  key: "trus_prostate",
  label: "УЗИ предстательной железы (ТРУЗИ)", labelKey: "usi.lbl.uzi_predstatelnoy_zhelezy_truzi",
  title: "ТРУЗИ предстательной железы", titleKey: "usi.lbl.truzi_predstatelnoy_zhelezy",
  heading: "ТРУЗИ предстательной железы", headingKey: "usi.lbl.truzi_predstatelnoy_zhelezy",
  headerItems: [text("psa", "ПСА общий / свободный (при наличии)")],
  blocks: [
    {
      title: "Предстательная железа", titleKey: "usi.lbl.predstatelnaya_zheleza",
      items: [
        text("prostate_transverse", "Поперечный размер, мм"),
        text("prostate_ap", "Переднезадний размер, мм"),
        text("prostate_cc", "Краниокаудальный размер, мм"),
        text("prostate_volume", "Объем, см³"),
        note(
          "prostate",
          "Предстательная железа расположена типично.\nФорма обычная, симметричная.\nКонтуры ровные, четкие.\nКапсула прослеживается на всем доступном исследованию протяжении, непрерывная.\nОбъем рассчитан по формуле эллипсоида: ширина × переднезадний размер × длина × 0,52.\nЭхогенность паренхимы обычная.\nЭхоструктура относительно однородная.",
          6,
        ),
      ],
    },
    {
      title: "Зональная анатомия", titleKey: "usi.lbl.zonalnaya_anatomiya",
      items: [
        note(
          "zones",
          "Дифференцировка центральной/переходной и периферической зон сохранена.\nПереходная зона не увеличена, симметричная, без выраженной узловой гиперплазии.\nПериферическая зона симметричная, однородная, без отчетливых очаговых изменений.\nОчаговые участки патологически сниженной или повышенной эхогенности не выявлены.\nОбъемные образования не выявлены.",
          5,
        ),
      ],
    },
    {
      title: "Периуретральная область и срединная доля", titleKey: "usi.lbl.periuretralnaya_oblast_i_sredinnaya_dolya",
      items: [
        note(
          "periurethral",
          "Периуретральные ткани без видимых патологических изменений.\nПростатическая часть уретры без видимых особенностей.\nСрединная доля не увеличена.\nВыраженного интравезикального роста ткани предстательной железы не определяется.",
          4,
        ),
      ],
    },
    {
      title: "Кальцинаты / конкременты", titleKey: "usi.lbl.kalcinaty_konkrementy",
      items: [
        note(
          "calcifications",
          "Патологических скоплений кальцинатов и конкрементов в паренхиме предстательной железы не выявлено.\nПротоки предстательной железы не расширены.",
          3,
        ),
      ],
    },
    {
      title: "Семенные пузырьки", titleKey: "usi.lbl.semennye_puzyrki",
      items: [
        note(
          "vesicles",
          "Семенные пузырьки расположены типично, симметричные.\nРазмеры не увеличены.\nКонтуры ровные, четкие.\nЭхоструктура однородная, соответствует обычной дольчатой структуре.\nПросветы не расширены.\nОчаговые и объемные образования не выявлены.",
          5,
        ),
      ],
    },
    {
      title: "Семявыносящие протоки", titleKey: "usi.lbl.semyavynosyaschie_protoki",
      items: [
        note(
          "vas",
          "Визуализируемые отделы семявыносящих протоков не расширены.\nПатологических изменений не выявлено.",
          2,
        ),
      ],
    },
    {
      title: "Цветовое / энергетическое допплеровское картирование", titleKey: "usi.lbl.cvetovoe_energeticheskoe_dopplerovskoe_kartirovanie",
      items: [
        note(
          "doppler",
          "Васкуляризация предстательной железы симметричная.\nПатологического локального или диффузного усиления кровотока не выявлено.\nУчастков патологической гиперваскуляризации не определяется.",
          3,
        ),
      ],
    },
    {
      title: "Парапростатические ткани", titleKey: "usi.lbl.paraprostaticheskie_tkani",
      items: [
        note(
          "paraprostatic",
          "Парапростатическая клетчатка без видимых патологических изменений.\nПризнаков распространения патологического процесса за пределы капсулы не выявлено.\nСвободная жидкость в исследуемой области не определяется.",
          3,
        ),
      ],
    },
    {
      title: "При выявлении очагового изменения", titleKey: "usi.lbl.pri_vyyavlenii_ochagovogo_izmeneniya",
      items: [
        text("lesion_location", "Локализация"),
        text("lesion_size", "Размеры, мм"),
        text("lesion_shape", "Форма", {
          placeholder: "овальная / округлая / неправильная", placeholderKey: "usi.lbl.ovalnaya_okruglaya_nepravilnaya",
        }),
        text("lesion_contours", "Контуры"),
        text("lesion_echo", "Эхогенность"),
        text("lesion_structure", "Эхоструктура"),
        text("lesion_calc", "Кальцинаты"),
        text("lesion_vascular", "Васкуляризация"),
        text("lesion_capsule", "Отношение к капсуле"),
        area("lesion_extra", "Дополнительные характеристики", { rows: 2 }),
      ],
    },
    conclusion(
      "Ультразвуковых признаков увеличения и структурных изменений предстательной железы на момент исследования не выявлено. Зональная дифференцировка сохранена. Очаговые образования не выявлены. Семенные пузырьки без видимых патологических изменений. Патологического усиления васкуляризации не определяется.",
    ),
    {
      title: "Примечание", titleKey: "usi.lbl.primechanie",
      items: [
        note(
          "remark",
          "Трансректальное ультразвуковое исследование не является методом, позволяющим надежно исключить клинически значимый рак предстательной железы. При наличии соответствующих клинических или лабораторных показаний дальнейшая диагностическая тактика определяется урологом с учетом уровня ПСА, пальцевого ректального исследования и данных мультипараметрической МРТ предстательной железы.",
          4,
        ),
      ],
    },
  ],
};

const lesionItems = (prefix) => [
  sel(`${prefix}_side`, "Сторона", SIDE_OPTIONS),
  text(`${prefix}_location`, "Локализация (часы, расстояние от соска, слой)"),
  text(`${prefix}_size`, "Размеры (3 измерения), мм"),
  text(`${prefix}_shape`, "Форма", {
    placeholder: "овальная / округлая / неправильная", placeholderKey: "usi.lbl.ovalnaya_okruglaya_nepravilnaya",
  }),
  text(`${prefix}_orientation`, "Ориентация", {
    placeholder: "параллельная коже / непараллельная коже", placeholderKey: "usi.lbl.parallelnaya_kozhe_neparallelnaya_kozhe",
  }),
  text(`${prefix}_contours`, "Контуры"),
  text(`${prefix}_echo`, "Эхогенность / эхоструктура"),
  text(`${prefix}_posterior`, "Задние акустические особенности"),
  text(`${prefix}_calc`, "Кальцинаты / эхогенные включения"),
  text(`${prefix}_vascular`, "Васкуляризация"),
  text(`${prefix}_elasto`, "Эластографические характеристики"),
  text(`${prefix}_relation`, "Связь с протоком / кожей / грудной стенкой"),
  text(`${prefix}_associated`, "Сопутствующие признаки"),
  text(`${prefix}_birads`, "Категория BI-RADS"),
];

const breastBiradsSchema = {
  key: "breast_birads",
  label: "УЗИ молочных желез (BI-RADS)", labelKey: "usi.lbl.uzi_molochnyh_zhelez_bi_rads",
  title: "УЗИ молочных желез BI RADS", titleKey: "usi.lbl.uzi_molochnyh_zhelez_bi_rads_2",
  heading: "УЗИ молочных желез (BI-RADS)", headingKey: "usi.lbl.uzi_molochnyh_zhelez_bi_rads",
  headerItems: [
    text("cycle_day", "День менструального цикла / менопауза"),
    text("previous_studies", "Предыдущие исследования"),
  ],
  blocks: [
    {
      title: "Общая характеристика", titleKey: "usi.lbl.obschaya_harakteristika",
      items: [
        note(
          "general",
          "Молочные железы симметричны.\nКожные покровы не изменены, не утолщены.\nСоски и ареолярные области без видимых ультразвуковых изменений.\nПодкожная жировая клетчатка обычной эхоструктуры.\nАрхитектоника тканей сохранена.",
          5,
        ),
      ],
    },
    {
      title: "Правая молочная железа", titleKey: "usi.lbl.pravaya_molochnaya_zheleza",
      items: [
        note(
          "right_breast",
          "Эхоструктура соответствует возрасту и гормональному статусу.\nКожа не утолщена. Подкожная клетчатка без особенностей.\nПаренхима без локальной архитектурной деформации.\nМлечные протоки не расширены, патологическое внутрипротоковое содержимое не определяется.\nРетроареолярная область без видимых патологических изменений.\nОчаговые солидные и кистозные образования не выявлены.\nУчастки нарушения архитектоники не определяются.\nПри цветовом допплеровском картировании патологической локальной гиперваскуляризации не выявлено.\nРетромаммарное пространство свободно.",
          8,
        ),
      ],
    },
    {
      title: "Левая молочная железа", titleKey: "usi.lbl.levaya_molochnaya_zheleza",
      items: [
        note(
          "left_breast",
          "Эхоструктура соответствует возрасту и гормональному статусу.\nКожа не утолщена. Подкожная клетчатка без особенностей.\nПаренхима без локальной архитектурной деформации.\nМлечные протоки не расширены, патологическое внутрипротоковое содержимое не определяется.\nРетроареолярная область без видимых патологических изменений.\nОчаговые солидные и кистозные образования не выявлены.\nУчастки нарушения архитектоники не определяются.\nПри цветовом допплеровском картировании патологической локальной гиперваскуляризации не выявлено.\nРетромаммарное пространство свободно.",
          8,
        ),
      ],
    },
    {
      title: "Регионарные лимфатические узлы", titleKey: "usi.lbl.regionarnye_limfaticheskie_uzly",
      items: [
        note(
          "lymph",
          "Подмышечные лимфатические узлы визуализируются с обеих сторон, обычной овальной формы, с сохраненной жировой воротной зоной и тонким равномерным корковым слоем.\nПодозрительных изменений коркового слоя, утраты жировых ворот и патологического сосудистого рисунка не выявлено.\nПодключичные и надключичные области: патологически измененные лимфатические узлы не выявлены.\nПарастернальные лимфатические узлы в доступных визуализации отделах не определяются / без подозрительных изменений.",
          5,
        ),
      ],
    },
    { title: "Очаговое образование № 1", titleKey: "usi.lbl.ochagovoe_obrazovanie_1", items: lesionItems("lesion1") },
    { title: "Очаговое образование № 2", titleKey: "usi.lbl.ochagovoe_obrazovanie_2", items: lesionItems("lesion2") },
    {
      title: "BI-RADS", titleKey: "usi.lbl.bi_rads",
      items: [
        note(
          "birads_memo",
          "BI-RADS 1 — отрицательный результат: патологические изменения не выявлены.\nBI-RADS 2 — доброкачественные изменения.\nBI-RADS 3 — вероятно доброкачественное образование; обычно требуется краткосрочное динамическое наблюдение.\nBI-RADS 4 — подозрительное изменение; рассматривается морфологическая верификация (4A / 4B / 4C).\nBI-RADS 5 — высокая вероятность злокачественного процесса.\nBI-RADS 6 — морфологически подтвержденное злокачественное новообразование.\nКатегория устанавливается по наиболее подозрительной находке с учетом полного комплекса данных.",
          7,
        ),
      ],
    },
    conclusion(
      "Ультразвуковых признаков очаговых и структурных патологических изменений молочных желез на момент исследования не выявлено. Патологически измененные регионарные лимфатические узлы не определяются.\nBI-RADS: правая молочная железа — 1; левая молочная железа — 1.",
    ),
    {
      title: "Рекомендации", titleKey: "usi.lbl.rekomendacii",
      items: [
        note(
          "recommendations",
          "Дальнейшая тактика и необходимость других методов визуализации определяются с учетом возраста, жалоб, факторов риска, клинического осмотра и действующей программы скрининга.",
          3,
        ),
      ],
    },
  ],
};

const pelvisFemaleSchema = {
  key: "pelvis_female",
  label: "УЗИ органов малого таза (женщины, ТА/ТВ)", labelKey: "usi.lbl.uzi_organov_malogo_taza_zhenschiny_ta_tv",
  title: "УЗИ органов малого таза женщины ТА ТВ", titleKey: "usi.lbl.uzi_organov_malogo_taza_zhenschiny_ta_tv_2",
  heading: "УЗИ органов малого таза (ТА / ТВ)", headingKey: "usi.lbl.uzi_organov_malogo_taza_ta_tv",
  headerItems: [
    text("cycle_day", "День менструального цикла / постменопауза"),
    text("last_menses", "Дата последней менструации"),
  ],
  blocks: [
    {
      title: "Матка", titleKey: "usi.lbl.matka",
      items: [
        text("uterus_position", "Положение", {
          placeholder: "anteversio / anteflexio", placeholderKey: "usi.lbl.anteversio_anteflexio",
        }),
        text("uterus_length", "Длина, мм"),
        text("uterus_ap", "Переднезадний размер, мм"),
        text("uterus_width", "Ширина, мм"),
        note(
          "uterus",
          "Матка расположена типично в полости малого таза.\nФорма обычная.\nКонтуры ровные, четкие.\nРазмеры матки соответствуют возрасту и репродуктивному статусу.\nМиометрий обычной эхогенности, эхоструктура однородная.\nОчаговые изменения миометрия не выявлены.\nПризнаков деформации наружного контура и полости матки не определяется.",
          6,
        ),
      ],
    },
    {
      title: "Шейка матки", titleKey: "usi.lbl.sheyka_matki",
      items: [
        text("cervix_length", "Длина, мм"),
        text("cervix_ap", "Переднезадний размер, мм"),
        note(
          "cervix",
          "Шейка матки обычной формы и эхоструктуры.\nЦервикальный канал не расширен, сомкнут.\nПатологическое содержимое в цервикальном канале не определяется.\nОчаговые и объемные образования шейки матки не выявлены.",
          4,
        ),
      ],
    },
    {
      title: "Эндометрий", titleKey: "usi.lbl.endometriy",
      items: [
        text("endometrium_mm", "М-эхо, мм"),
        note(
          "endometrium",
          "Эндометрий визуализируется отчетливо.\nТолщина и эхоструктура эндометрия соответствуют фазе менструального цикла / репродуктивному статусу.\nКонтур эндометрия ровный.\nЭндометрий однородный.\nГраница эндометрий–миометрий четкая, ровная.\nПолость матки не расширена, не деформирована.\nПатологическое содержимое и очаговые внутриполостные образования не выявлены.",
          6,
        ),
      ],
    },
    {
      title: "Правый яичник", titleKey: "usi.lbl.pravyy_yaichnik",
      items: [
        text("right_ov_length", "Длина, мм"),
        text("right_ov_width", "Ширина, мм"),
        text("right_ov_thickness", "Толщина, мм"),
        text("right_ov_volume", "Объем, см³"),
        text(
          "right_ov_follicles",
          "Фолликулы / доминантный фолликул / желтое тело",
        ),
        note(
          "right_ovary",
          "Расположен типично, визуализируется.\nКонтуры ровные, четкие.\nСтрома обычной эхогенности и эхоструктуры.\nФолликулярный аппарат соответствует возрасту и фазе менструального цикла.\nОчаговые, кистозные и солидные патологические образования не выявлены.\nПри ЦДК патологической васкуляризации не определяется.",
          5,
        ),
      ],
    },
    {
      title: "Левый яичник", titleKey: "usi.lbl.levyy_yaichnik",
      items: [
        text("left_ov_length", "Длина, мм"),
        text("left_ov_width", "Ширина, мм"),
        text("left_ov_thickness", "Толщина, мм"),
        text("left_ov_volume", "Объем, см³"),
        text(
          "left_ov_follicles",
          "Фолликулы / доминантный фолликул / желтое тело",
        ),
        note(
          "left_ovary",
          "Расположен типично, визуализируется.\nКонтуры ровные, четкие.\nСтрома обычной эхогенности и эхоструктуры.\nФолликулярный аппарат соответствует возрасту и фазе менструального цикла.\nОчаговые, кистозные и солидные патологические образования не выявлены.\nПри ЦДК патологической васкуляризации не определяется.",
          5,
        ),
      ],
    },
    {
      title: "Маточные трубы / придатки", titleKey: "usi.lbl.matochnye_truby_pridatki",
      items: [
        note(
          "adnexa",
          "Маточные трубы при отсутствии их расширения отдельно не визуализируются.\nОбъемные и жидкостные образования в проекции придатков не выявлены.",
          3,
        ),
      ],
    },
    {
      title: "Позадиматочное пространство", titleKey: "usi.lbl.pozadimatochnoe_prostranstvo",
      items: [
        note(
          "pouch",
          "Свободная жидкость в позадиматочном пространстве не определяется / определяется в физиологическом количестве, соответствующем фазе цикла.\nПатологические объемные образования в полости малого таза не выявлены.",
          3,
        ),
      ],
    },
    {
      title: "Цветовое / энергетическое допплеровское картирование", titleKey: "usi.lbl.cvetovoe_energeticheskoe_dopplerovskoe_kartirovanie",
      items: [
        note(
          "doppler",
          "Васкуляризация миометрия без патологических особенностей.\nПатологического локального усиления кровотока в матке и придатках не выявлено.",
          3,
        ),
      ],
    },
    {
      title: "При выявлении образования яичника / придатков", titleKey: "usi.lbl.pri_vyyavlenii_obrazovaniya_yaichnika_pridatkov",
      items: [
        text("mass_location", "Сторона / локализация"),
        text("mass_size", "Размеры, мм"),
        text("mass_type", "Тип", {
          placeholder:
            "унилокулярное / унилокулярно-солидное / мультилокулярное / солидное",
        }),
        text("mass_content", "Содержимое"),
        text("mass_wall", "Внутренняя стенка"),
        text("mass_septa", "Перегородки"),
        text("mass_solid", "Солидный компонент"),
        text("mass_papillae", "Папиллярные структуры"),
        sel("mass_shadow", "Акустические тени", ABSENT_PLURAL),
        text("mass_color", "Цветовой балл / васкуляризация"),
        sel("mass_ascites", "Асцит", ABSENT_PRESENT),
        area("mass_extra", "Дополнительные признаки", { rows: 2 }),
        text("mass_adnex", "Оценка риска IOTA ADNEX / иная система"),
      ],
    },
    conclusion(
      "Ультразвуковых признаков структурных патологических изменений органов малого таза на момент исследования не выявлено. Размеры и эхоструктура матки без особенностей. Эндометрий соответствует фазе менструального цикла / репродуктивному статусу. Яичники без патологических очаговых образований, фолликулярный аппарат соответствует возрасту и фазе цикла. Патологических образований в области придатков не выявлено.",
    ),
    {
      title: "Примечание", titleKey: "usi.lbl.primechanie",
      items: [
        note(
          "remark",
          "Толщина и эхоструктура эндометрия, размеры яичников и характер фолликулярного аппарата интерпретируются с учетом возраста, дня менструального цикла, гормональной терапии и менопаузального статуса. У пациенток в постменопаузе заключение должно формироваться с учетом клинических данных, в том числе наличия или отсутствия маточного кровотечения.",
          4,
        ),
      ],
    },
  ],
};

const scrotumSchema = {
  key: "scrotum",
  label: "УЗИ органов мошонки (ЦДК)", labelKey: "usi.lbl.uzi_organov_moshonki_cdk",
  title: "УЗИ органов мошонки ЦДК", titleKey: "usi.lbl.uzi_organov_moshonki_cdk_2",
  heading: "УЗИ органов мошонки с ЦДК", headingKey: "usi.lbl.uzi_organov_moshonki_s_cdk",
  blocks: [
    {
      title: "Мошонка", titleKey: "usi.lbl.moshonka",
      items: [
        note(
          "scrotum",
          "Кожа мошонки не утолщена.\nОболочки яичек без видимых патологических изменений.\nСвободная жидкость между листками влагалищных оболочек в патологическом количестве не определяется.\nДополнительные объемные образования мягких тканей мошонки не выявлены.",
          4,
        ),
      ],
    },
    {
      title: "Правое яичко", titleKey: "usi.lbl.pravoe_yaichko",
      items: [
        text("right_length", "Длина, мм"),
        text("right_width", "Ширина, мм"),
        text("right_ap", "Переднезадний размер, мм"),
        text("right_volume", "Объем, мл"),
        note(
          "right_testis",
          "Расположено в мошонке.\nФорма овальная, контуры ровные, четкие.\nРазмеры и объем соответствуют возрасту.\nПаренхима однородная, средней эхогенности.\nОчаговые и объемные образования не выявлены.\nБелочная оболочка без видимых изменений.\nСредостение яичка визуализируется, без особенностей.\nПри цветовом/энергетическом допплеровском картировании интратестикулярный кровоток сохранен, равномерный.",
          7,
        ),
      ],
    },
    {
      title: "Придаток правого яичка", titleKey: "usi.lbl.pridatok_pravogo_yaichka",
      items: [
        text("right_epididymis_head", "Размер головки придатка, мм"),
        note(
          "right_epididymis",
          "Головка придатка визуализируется, не увеличена.\nТело и хвост без видимых патологических изменений.\nЭхоструктура однородная.\nОчаговые и кистозные образования не выявлены.\nПатологического усиления васкуляризации не определяется.",
          5,
        ),
      ],
    },
    {
      title: "Левое яичко", titleKey: "usi.lbl.levoe_yaichko",
      items: [
        text("left_length", "Длина, мм"),
        text("left_width", "Ширина, мм"),
        text("left_ap", "Переднезадний размер, мм"),
        text("left_volume", "Объем, мл"),
        note(
          "left_testis",
          "Расположено в мошонке.\nФорма овальная, контуры ровные, четкие.\nРазмеры и объем соответствуют возрасту.\nПаренхима однородная, средней эхогенности.\nОчаговые и объемные образования не выявлены.\nБелочная оболочка без видимых изменений.\nСредостение яичка визуализируется, без особенностей.\nПри цветовом/энергетическом допплеровском картировании интратестикулярный кровоток сохранен, равномерный.",
          7,
        ),
      ],
    },
    {
      title: "Придаток левого яичка", titleKey: "usi.lbl.pridatok_levogo_yaichka",
      items: [
        text("left_epididymis_head", "Размер головки придатка, мм"),
        note(
          "left_epididymis",
          "Головка придатка визуализируется, не увеличена.\nТело и хвост без видимых патологических изменений.\nЭхоструктура однородная.\nОчаговые и кистозные образования не выявлены.\nПатологического усиления васкуляризации не определяется.",
          5,
        ),
      ],
    },
    {
      title: "Допплерография", titleKey: "usi.lbl.dopplerografiya",
      items: [
        text("right_psv", "Правая сторона: PSV, см/с"),
        text("right_edv", "Правая сторона: EDV, см/с"),
        text("right_ri", "Правая сторона: RI"),
        text("left_psv", "Левая сторона: PSV, см/с"),
        text("left_edv", "Левая сторона: EDV, см/с"),
        text("left_ri", "Левая сторона: RI"),
        note(
          "doppler",
          "Васкуляризация паренхимы правого и левого яичек симметричная.\nПризнаков локального или диффузного усиления либо обеднения интратестикулярного кровотока не выявлено.\nАртериальный и венозный кровоток в паренхиме яичек определяется.",
          4,
        ),
      ],
    },
    {
      title: "Вены лозовидного сплетения", titleKey: "usi.lbl.veny_lozovidnogo_spleteniya",
      items: [
        text(
          "pampiniform_right",
          "Максимальный диаметр вен справа в покое, мм",
        ),
        text("pampiniform_left", "Максимальный диаметр вен слева в покое, мм"),
        note(
          "pampiniform",
          "Вены лозовидного сплетения с обеих сторон не расширены.\nПри цветовом допплеровском картировании патологический венозный рефлюкс в покое не определяется.\nПри пробе Вальсальвы патологический венозный рефлюкс не определяется.\nУльтразвуковых признаков варикоцеле не выявлено.",
          4,
        ),
      ],
    },
    {
      title: "Семенные канатики", titleKey: "usi.lbl.semennye_kanatiki",
      items: [
        note(
          "spermatic",
          "Семенные канатики в доступных визуализации отделах без видимых патологических изменений.\nОбъемные образования не выявлены.",
          2,
        ),
      ],
    },
    {
      title: "При выявлении очагового образования", titleKey: "usi.lbl.pri_vyyavlenii_ochagovogo_obrazovaniya",
      items: [
        text("lesion_location", "Локализация"),
        text("lesion_intra", "Интра- / экстратестикулярное расположение"),
        text("lesion_size", "Размеры, мм"),
        text("lesion_shape", "Форма"),
        text("lesion_contours", "Контуры"),
        text("lesion_echo", "Эхогенность"),
        text("lesion_structure", "Эхоструктура"),
        text("lesion_calc", "Кальцинаты / эхогенные включения"),
        text("lesion_posterior", "Задние акустические эффекты"),
        text("lesion_vascular", "Васкуляризация"),
        text("lesion_relation", "Связь с окружающими структурами"),
      ],
    },
    conclusion(
      "Ультразвуковых признаков структурных изменений органов мошонки на момент исследования не выявлено. Эхоструктура и васкуляризация обоих яичек сохранены, симметричны. Очаговые и объемные образования не выявлены. Патологического количества жидкости в оболочках яичек не определяется. Ультразвуковых признаков варикоцеле не выявлено.",
    ),
  ],
};

const liverBiliarySchema = {
  key: "liver_biliary",
  label: "УЗИ печени и желчевыводящей системы", labelKey: "usi.lbl.uzi_pecheni_i_zhelchevyvodyaschey_sistemy",
  title: "УЗИ печени и желчевыводящей системы", titleKey: "usi.lbl.uzi_pecheni_i_zhelchevyvodyaschey_sistemy",
  heading: "УЗИ печени и желчевыводящей системы", headingKey: "usi.lbl.uzi_pecheni_i_zhelchevyvodyaschey_sistemy",
  headerItems: [
    {
      name: "conditions",
      label: "Условия исследования", labelKey: "usi.lbl.usloviya_issledovaniya",
      type: "textarea",
      rows: 2,
      default:
        "исследование выполнено натощак. Визуализация удовлетворительная.",
    },
  ],
  blocks: [
    {
      title: "Печень", titleKey: "usi.lbl.pechen",
      items: [
        text("liver_right_cv", "Правая доля, косой вертикальный размер, мм"),
        text("liver_right_ap", "Правая доля, переднезадний размер, мм"),
        text("liver_left_ap", "Левая доля, переднезадний размер, мм"),
        text("caudate", "Хвостатая доля, мм"),
        note(
          "liver",
          "Печень расположена обычно, не выступает из-под края правой реберной дуги.\nФорма обычная.\nКонтуры ровные, четкие.\nКапсула визуализируется отчетливо, не утолщена.\nРазмеры печени не увеличены.\nКрая печени не закруглены.\nЭхогенность паренхимы обычная, сопоставима с корковым веществом правой почки.\nЭхоструктура паренхимы однородная, мелкозернистая.\nЗвукопроводимость сохранена.\nСосудистый рисунок сохранен, не деформирован.\nОчаговые и объемные образования в паренхиме печени не выявлены.",
          8,
        ),
      ],
    },
    {
      title: "Сосуды печени", titleKey: "usi.lbl.sosudy_pecheni",
      items: [
        text("portal_vein", "Диаметр воротной вены, мм"),
        note(
          "liver_vessels",
          "Воротная вена визуализируется, не расширена.\nПросвет воротной вены свободный, анэхогенный.\nПри цветовом допплеровском картировании кровоток в воротной вене определяется, гепатопетальный.\nПеченочные вены визуализируются, не расширены. Просвет свободный.\nНижняя полая вена визуализируется, не расширена.\nВ доступных исследованию отделах патологических изменений сосудистых структур печени не выявлено.",
          6,
        ),
      ],
    },
    {
      title: "Внутрипеченочные желчные протоки", titleKey: "usi.lbl.vnutripechenochnye_zhelchnye_protoki",
      items: [
        note(
          "ihbd",
          "Внутрипеченочные желчные протоки не расширены.\nСтенки визуализируемых желчных протоков не утолщены.\nВнутрипросветные образования и конкременты не определяются.",
          3,
        ),
      ],
    },
    {
      title: "Желчный пузырь", titleKey: "usi.lbl.zhelchnyy_puzyr",
      items: [
        text("gb_size", "Размеры, мм"),
        text("gb_wall", "Толщина стенки, мм"),
        note(
          "gallbladder",
          "Желчный пузырь расположен типично.\nФорма обычная, деформаций не выявлено.\nЖелчный пузырь не увеличен.\nКонтуры ровные, четкие.\nСтенка не утолщена, однородная.\nСодержимое однородное, анэхогенное.\nБилиарный сладж и эхогенная взвесь не определяются.\nКонкременты в просвете желчного пузыря не определяются.\nПолиповидные и другие внутрипросветные образования не выявлены.\nПеривезикальная клетчатка не изменена.\nЖидкостные скопления в области желчного пузыря не определяются.",
          8,
        ),
      ],
    },
    {
      title: "Внепеченочные желчные протоки", titleKey: "usi.lbl.vnepechenochnye_zhelchnye_protoki",
      items: [
        text("chd", "Диаметр общего печеночного протока, мм"),
        text("cbd", "Диаметр общего желчного протока, мм"),
        note(
          "ehbd",
          "Общий печеночный проток визуализируется, не расширен.\nОбщий желчный проток визуализируется на доступном исследованию протяжении, не расширен.\nПросвет однородный, свободный.\nСтенки не утолщены.\nКонкременты и другие внутрипросветные образования не определяются.\nПризнаков внутри- и внепеченочной билиарной гипертензии не выявлено.",
          5,
        ),
      ],
    },
    {
      title: "Область ворот печени", titleKey: "usi.lbl.oblast_vorot_pecheni",
      items: [
        note(
          "porta",
          "Патологические объемные образования в области ворот печени не выявлены.\nУвеличенные и патологически измененные лимфатические узлы в доступных визуализации отделах не определяются.",
          3,
        ),
      ],
    },
    {
      title: "Свободная жидкость", titleKey: "usi.lbl.svobodnaya_zhidkost",
      items: [
        note(
          "free_fluid",
          "Свободная жидкость в перигепатическом и подпеченочном пространствах не определяется.",
          2,
        ),
      ],
    },
    conclusion(
      "Ультразвуковых признаков структурных изменений печени, желчного пузыря и желчевыводящих путей на момент исследования не выявлено. Внутри- и внепеченочные желчные протоки не расширены.",
    ),
  ],
};

const lymphNodesSchema = {
  key: "lymph_nodes",
  label: "УЗИ поверхностных лимфатических узлов", labelKey: "usi.lbl.uzi_poverhnostnyh_limfaticheskih_uzlov",
  title: "УЗИ поверхностных лимфатических узлов", titleKey: "usi.lbl.uzi_poverhnostnyh_limfaticheskih_uzlov",
  heading: "УЗИ поверхностных лимфатических узлов", headingKey: "usi.lbl.uzi_poverhnostnyh_limfaticheskih_uzlov",
  headerItems: [
    text("zones", "Исследуемые зоны", {
      placeholder:
        "шейные / надключичные / подключичные / подмышечные / локтевые / паховые / другие",
    }),
  ],
  blocks: [
    {
      title: "Общая ультразвуковая характеристика", titleKey: "usi.lbl.obschaya_ultrazvukovaya_harakteristika",
      items: [
        note(
          "general",
          "В исследованных анатомических областях визуализируемые лимфатические узлы имеют обычную ультразвуковую структуру.\nФорма преимущественно овальная.\nКонтуры ровные, четкие.\nКорковый слой тонкий, равномерный, без локального утолщения.\nКортико-медуллярная дифференцировка сохранена.\nЖировые ворота сохранены.\nПризнаков кистозной дегенерации, некроза, патологических эхогенных включений и кальцинатов не выявлено.\nПерифокальные ткани без видимых патологических изменений.\nПри цветовом/энергетическом допплеровском картировании сосудистый рисунок обычный, преимущественно воротного типа; патологической периферической или смешанной гиперваскуляризации не выявлено.",
          8,
        ),
      ],
    },
    {
      title: "Шейные лимфатические узлы", titleKey: "usi.lbl.sheynye_limfaticheskie_uzly",
      items: [
        note(
          "cervical",
          "Справа и слева визуализируемые шейные лимфатические узлы обычной овальной формы и сохраненной архитектоники. Подозрительных ультразвуковых изменений не выявлено.",
          3,
        ),
      ],
    },
    {
      title: "Надключичные и подключичные лимфатические узлы", titleKey: "usi.lbl.nadklyuchichnye_i_podklyuchichnye_limfaticheskie_uzly",
      items: [
        note(
          "clavicular",
          "Патологически измененные надключичные и подключичные лимфатические узлы с обеих сторон не выявлены.",
          2,
        ),
      ],
    },
    {
      title: "Подмышечные лимфатические узлы", titleKey: "usi.lbl.podmyshechnye_limfaticheskie_uzly",
      items: [
        note(
          "axillary",
          "Подмышечные лимфатические узлы с обеих сторон овальной формы, с сохраненными жировыми воротами и тонким равномерным корковым слоем. Подозрительных изменений не выявлено.",
          3,
        ),
      ],
    },
    {
      title: "Локтевые лимфатические узлы", titleKey: "usi.lbl.loktevye_limfaticheskie_uzly",
      items: [
        note(
          "elbow",
          "Патологически измененные лимфатические узлы в локтевых областях не выявлены.",
          2,
        ),
      ],
    },
    {
      title: "Паховые лимфатические узлы", titleKey: "usi.lbl.pahovye_limfaticheskie_uzly",
      items: [
        note(
          "inguinal",
          "Визуализируемые паховые лимфатические узлы с обеих сторон имеют овальную форму, сохраненную внутреннюю архитектонику и жировые ворота. Подозрительных изменений не выявлено.",
          3,
        ),
      ],
    },
    {
      title: "Описание измененного / доминантного лимфатического узла", titleKey: "usi.lbl.opisanie_izmenennogo_dominantnogo_limfaticheskogo_uzla",
      items: [
        text("node_location", "Локализация / анатомическая группа"),
        sel("node_side", "Сторона", SIDE_OPTIONS),
        text("node_count", "Количество", {
          placeholder: "единичный / множественные", placeholderKey: "usi.lbl.edinichnyy_mnozhestvennye",
        }),
        text("node_long", "Длинная ось, мм"),
        text("node_short", "Короткая ось, мм"),
        text("node_ls", "Соотношение длинной и короткой осей (L/S)"),
        text("node_shape", "Форма"),
        text("node_contours", "Контуры"),
        text("node_cortex", "Корковый слой"),
        text("node_hilum", "Жировые ворота"),
        text("node_cmd", "Кортико-медуллярная дифференцировка"),
        text("node_echo", "Эхогенность / эхоструктура"),
        text("node_necrosis", "Некроз / кистозные изменения"),
        text("node_calc", "Кальцинаты / эхогенные включения"),
        text("node_vascular", "Васкуляризация"),
        text("node_peri", "Перифокальные ткани"),
        text("node_conglomerate", "Конгломераты"),
      ],
    },
    conclusion(
      "Ультразвуковых признаков патологических изменений исследованных поверхностных лимфатических узлов на момент исследования не выявлено. Визуализируемые лимфатические узлы имеют сохраненную архитектонику и обычный характер васкуляризации.",
    ),
    {
      title: "Примечание", titleKey: "usi.lbl.primechanie",
      items: [
        note(
          "remark",
          "Размер лимфатического узла оценивается совместно с его локализацией, формой, толщиной и характером коркового слоя, состоянием жировых ворот, внутренней архитектоникой и типом васкуляризации. Изолированный линейный размер не используется как единственный критерий доброкачественности или патологического изменения.",
          4,
        ),
      ],
    },
  ],
};

const prostateTaSchema = {
  key: "prostate_ta",
  label: "УЗИ предстательной железы (трансабдоминально)", labelKey: "usi.lbl.uzi_predstatelnoy_zhelezy_transabdominalno",
  title: "УЗИ предстательной железы трансабдоминально", titleKey: "usi.lbl.uzi_predstatelnoy_zhelezy_transabdominalno_2",
  heading: "УЗИ предстательной железы (трансабдоминально)", headingKey: "usi.lbl.uzi_predstatelnoy_zhelezy_transabdominalno",
  blocks: [
    {
      title: "Мочевой пузырь", titleKey: "usi.lbl.mochevoy_puzyr",
      items: [
        text("bladder_volume", "Объем до мочеиспускания, мл"),
        text("bladder_wall", "Толщина стенки, мм"),
        note(
          "bladder",
          "Мочевой пузырь наполнен, расположен типично.\nФорма правильная. Контуры ровные, четкие.\nСтенки ровные, не утолщены.\nСодержимое однородное, анэхогенное.\nВнутрипросветные образования, конкременты и эхогенная взвесь не определяются.",
          5,
        ),
      ],
    },
    {
      title: "Предстательная железа", titleKey: "usi.lbl.predstatelnaya_zheleza",
      items: [
        text("prostate_transverse", "Поперечный размер, мм"),
        text("prostate_ap", "Переднезадний размер, мм"),
        text("prostate_cc", "Краниокаудальный размер, мм"),
        text("prostate_volume", "Объем, см³"),
        note(
          "prostate",
          "Предстательная железа расположена типично.\nФорма обычная, симметричная.\nКонтуры ровные, четкие.\nОбъем рассчитан по формуле эллипсоида: ширина × переднезадний размер × длина × 0,52.\nЭхогенность паренхимы обычная.\nЭхоструктура относительно однородная.\nОчаговые и объемные образования при трансабдоминальном исследовании не выявлены.\nВыраженных участков патологической кальцинации не определяется.\nКапсула визуализируется на доступном исследованию протяжении, контур сохранен.\nПростатическая часть уретры без видимых особенностей.",
          8,
        ),
      ],
    },
    {
      title: "Срединная доля / интравезикальная протрузия", titleKey: "usi.lbl.sredinnaya_dolya_intravezikalnaya_protruziya",
      items: [
        text("ipp", "Интравезикальная простатическая протрузия, мм", {
          placeholder: "не определяется / мм", placeholderKey: "usi.lbl.ne_opredelyaetsya_mm",
        }),
        note(
          "median_lobe",
          "Выраженного выбухания ткани предстательной железы в просвет мочевого пузыря не определяется.",
          2,
        ),
      ],
    },
    {
      title: "Семенные пузырьки", titleKey: "usi.lbl.semennye_puzyrki",
      items: [
        note(
          "vesicles",
          "Семенные пузырьки визуализируются с обеих сторон, симметричные.\nНе расширены, эхоструктура без видимых патологических изменений.\nОбъемные образования не выявлены.",
          3,
        ),
      ],
    },
    {
      title: "Цветовое допплеровское картирование", titleKey: "usi.lbl.cvetovoe_dopplerovskoe_kartirovanie",
      items: [
        note(
          "doppler",
          "При цветовом/энергетическом допплеровском картировании патологического локального усиления васкуляризации предстательной железы не выявлено.",
          2,
        ),
      ],
    },
    {
      title: "Остаточная моча", titleKey: "usi.lbl.ostatochnaya_mocha",
      items: [
        text(
          "postvoid_volume",
          "Объем мочевого пузыря после мочеиспускания, мл",
        ),
        text("residual_volume", "Объем остаточной мочи, мл"),
        note(
          "residual_note",
          "Значимого объема остаточной мочи не определяется.",
          2,
        ),
      ],
    },
    conclusion(
      "Ультразвуковых признаков увеличения и выраженных структурных изменений предстательной железы при трансабдоминальном исследовании не выявлено. Семенные пузырьки без видимых патологических изменений. Значимого объема остаточной мочи не определяется.",
    ),
    {
      title: "Примечание", titleKey: "usi.lbl.primechanie",
      items: [
        note(
          "remark",
          "Трансабдоминальное ультразвуковое исследование имеет ограничения в детальной оценке зональной анатомии и небольших очаговых изменений предстательной железы. При наличии клинических показаний дальнейшая тактика определяется урологом с учетом данных осмотра, лабораторных показателей и других методов визуализации.",
          4,
        ),
      ],
    },
  ],
};

const jointsSchema = {
  key: "joints",
  label: "УЗИ суставов и периартикулярных мягких тканей", labelKey: "usi.lbl.uzi_sustavov_i_periartikulyarnyh_myagkih_tkaney",
  title: "УЗИ суставов и периартикулярных мягких тканей", titleKey: "usi.lbl.uzi_sustavov_i_periartikulyarnyh_myagkih_tkaney",
  heading: "УЗИ сустава и периартикулярных мягких тканей", headingKey: "usi.lbl.uzi_sustava_i_periartikulyarnyh_myagkih_tkaney",
  headerItems: [
    text("joint_area", "Исследуемая область / сустав"),
    sel("joint_side", "Сторона", SIDE_BOTH_OPTIONS),
  ],
  blocks: [
    {
      title: "Сустав", titleKey: "usi.lbl.sustav",
      items: [
        note(
          "joint",
          "Суставные поверхности конгруэнтны.\nКортикальные контуры доступных визуализации костных структур ровные, непрерывные.\nУльтразвуковых признаков эрозивных изменений не выявлено.\nСуставной хрящ в доступных оценке отделах однородный, с ровными контурами, без отчетливых локальных дефектов.\nСуставная щель ультразвуково без грубых изменений.\nПатологического выпота в полости сустава не определяется.\nСиновиальная оболочка не утолщена, признаков синовиальной гипертрофии не выявлено.\nПри ЦДК/ЭДК патологической внутрисиновиальной васкуляризации не определяется.",
          7,
        ),
      ],
    },
    {
      title: "Суставная капсула и связки", titleKey: "usi.lbl.sustavnaya_kapsula_i_svyazki",
      items: [
        note(
          "capsule",
          "Капсула сустава не утолщена, целостность сохранена.\nИсследованные связки имеют непрерывный фибриллярный рисунок, обычную толщину и эхогенность.\nПризнаков частичного или полного повреждения связок не выявлено.\nПерифокального отека и патологической гиперваскуляризации не определяется.",
          4,
        ),
      ],
    },
    {
      title: "Сухожилия", titleKey: "usi.lbl.suhozhiliya",
      items: [
        note(
          "tendons",
          "Исследованные сухожилия прослеживаются на доступном протяжении.\nКонтуры ровные, четкие.\nТолщина не увеличена.\nФибриллярная эхоструктура сохранена, эхогенность обычная.\nПризнаков тендинопатии, частичного или полного разрыва не выявлено.\nЖидкость в сухожильных влагалищах в патологическом количестве не определяется.\nПризнаков теносиновита не выявлено.\nПри ЦДК/ЭДК патологической гиперваскуляризации не определяется.",
          7,
        ),
      ],
    },
    {
      title: "Энтезисы", titleKey: "usi.lbl.entezisy",
      items: [
        note(
          "entheses",
          "Исследованные энтезисы без утолщения и структурной неоднородности.\nКортикальный контур в местах прикрепления сухожилий/связок ровный.\nЭнтезофиты, эрозии и патологические кальцинаты не выявлены.\nПатологической васкуляризации в зоне энтезисов не определяется.",
          4,
        ),
      ],
    },
    {
      title: "Бурсы", titleKey: "usi.lbl.bursy",
      items: [
        note(
          "bursae",
          "Исследованные синовиальные сумки не расширены.\nПатологического жидкостного содержимого и утолщения стенок не выявлено.\nУльтразвуковых признаков бурсита не определяется.",
          3,
        ),
      ],
    },
    {
      title: "Мышцы и подкожные мягкие ткани", titleKey: "usi.lbl.myshcy_i_podkozhnye_myagkie_tkani",
      items: [
        note(
          "muscles",
          "Исследованные мышцы имеют сохраненную архитектонику и обычную эхогенность.\nПризнаков разрыва мышечных волокон, гематомы или патологического жидкостного скопления не выявлено.\nПодкожная клетчатка без выраженных структурных изменений.\nОчаговые и объемные образования в исследованной области не выявлены.",
          4,
        ),
      ],
    },
    {
      title: "Динамическое исследование", titleKey: "usi.lbl.dinamicheskoe_issledovanie",
      items: [
        note(
          "dynamic",
          "При выполнении функциональных/динамических проб патологического смещения сухожилий и признаков механического импинджмента в исследованной области не выявлено.\nДинамическая стабильность исследованных структур сохранена.",
          3,
        ),
      ],
    },
    {
      title: "При выявлении патологического изменения", titleKey: "usi.lbl.pri_vyyavlenii_patologicheskogo_izmeneniya",
      items: [
        text("path_structure", "Структура / локализация"),
        text("path_size", "Размеры патологического участка, мм"),
        text("path_echo", "Эхогенность"),
        text("path_structure_type", "Эхоструктура"),
        text("path_contours", "Контуры"),
        text("path_fluid", "Жидкость / выпот"),
        text("path_synovium", "Синовиальная гипертрофия"),
        text("path_doppler", "Power/Color Doppler активность"),
        text("path_calc", "Кальцинаты / энтезофиты / эрозии"),
        text("path_tendon", "Сухожилие"),
        text("path_ligament", "Связка"),
        text("path_dynamic", "Динамические признаки"),
      ],
    },
    conclusion(
      "Ультразвуковых признаков структурных патологических изменений исследованного сустава и периартикулярных мягких тканей на момент исследования не выявлено. Патологический выпот и синовиальная гипертрофия не определяются. Сухожильно-связочный аппарат без ультразвуковых признаков повреждения. Признаков бурсита, теносиновита и патологической гиперваскуляризации не выявлено.",
    ),
    {
      title: "Примечание", titleKey: "usi.lbl.primechanie",
      items: [
        note(
          "remark",
          "Конкретный набор анатомических структур и динамических проб зависит от исследуемого сустава (плечевой, локтевой, лучезапястный/кисть, тазобедренный, коленный, голеностопный/стопа) и клинической задачи. При воспалительных артропатиях синовит и допплеровская активность могут оцениваться по валидированным шкалам OMERACT/EULAR.",
          4,
        ),
      ],
    },
  ],
};

const thyroidNodeItems = (prefix) => [
  text(`${prefix}_location`, "Локализация"),
  text(`${prefix}_size`, "Размеры (3 ортогональных), мм"),
  text(`${prefix}_composition`, "Состав", {
    placeholder:
      "солидный / преимущественно солидный / смешанный / кистозный / губчатый",
  }),
  text(`${prefix}_echo`, "Эхогенность солидного компонента"),
  text(`${prefix}_shape`, "Форма; выше, чем шире"),
  text(`${prefix}_contours`, "Контуры"),
  text(`${prefix}_foci`, "Эхогенные включения"),
  text(`${prefix}_ete`, "Экстратиреоидное распространение"),
  text(`${prefix}_vascular`, "Васкуляризация"),
  text(`${prefix}_tirads`, "EU-TIRADS", { placeholder: "2 / 3 / 4 / 5", placeholderKey: "usi.lbl.2_3_4_5" }),
  text(
    `${prefix}_dynamics`,
    "Динамика по сравнению с предыдущим исследованием",
  ),
];

const thyroidSchema = {
  key: "thyroid_eutirads",
  label: "УЗИ щитовидной железы (EU-TIRADS)", labelKey: "usi.lbl.uzi_schitovidnoy_zhelezy_eu_tirads",
  title: "УЗИ щитовидной железы EU TIRADS", titleKey: "usi.lbl.uzi_schitovidnoy_zhelezy_eu_tirads_2",
  heading: "УЗИ щитовидной железы (EU-TIRADS)", headingKey: "usi.lbl.uzi_schitovidnoy_zhelezy_eu_tirads",
  blocks: [
    {
      title: "Щитовидная железа", titleKey: "usi.lbl.schitovidnaya_zheleza",
      items: [
        text("isthmus", "Переднезадний размер перешейка, мм"),
        note(
          "thyroid",
          "Расположена типично.\nФорма обычная.\nКонтуры ровные, четкие.\nКапсула визуализируется отчетливо, не утолщена.\nПерешеек не утолщен.",
          4,
        ),
      ],
    },
    {
      title: "Правая доля", titleKey: "usi.lbl.pravaya_dolya",
      items: [
        text("right_length", "Длина, мм"),
        text("right_width", "Ширина, мм"),
        text("right_thickness", "Толщина, мм"),
        text("right_volume", "Объем правой доли, мл"),
        note(
          "right_lobe",
          "Контуры ровные, четкие.\nЭхогенность паренхимы обычная.\nЭхоструктура однородная.\nОчаговые образования не выявлены.",
          4,
        ),
      ],
    },
    {
      title: "Левая доля", titleKey: "usi.lbl.levaya_dolya",
      items: [
        text("left_length", "Длина, мм"),
        text("left_width", "Ширина, мм"),
        text("left_thickness", "Толщина, мм"),
        text("left_volume", "Объем левой доли, мл"),
        note(
          "left_lobe",
          "Контуры ровные, четкие.\nЭхогенность паренхимы обычная.\nЭхоструктура однородная.\nОчаговые образования не выявлены.",
          4,
        ),
      ],
    },
    {
      title: "Объем щитовидной железы", titleKey: "usi.lbl.obem_schitovidnoy_zhelezy",
      items: [
        text("total_volume", "Суммарный объем, мл"),
        note(
          "volume_note",
          "Объем рассчитывается по формуле: длина × ширина × толщина × 0,479 для каждой доли с последующим суммированием объемов долей.\nРазмеры и объем щитовидной железы оцениваются с учетом пола, возраста и клинического контекста.",
          3,
        ),
      ],
    },
    {
      title: "Васкуляризация", titleKey: "usi.lbl.vaskulyarizaciya",
      items: [
        note(
          "vascular",
          "При цветовом/энергетическом допплеровском картировании васкуляризация паренхимы щитовидной железы обычная, симметричная.\nДиффузного усиления или обеднения кровотока не выявлено.",
          3,
        ),
      ],
    },
    {
      title: "Регионарные лимфатические узлы", titleKey: "usi.lbl.regionarnye_limfaticheskie_uzly",
      items: [
        note(
          "lymph",
          "Шейные лимфатические узлы в доступных визуализации областях без подозрительных ультразвуковых изменений.\nПатологически измененные регионарные лимфатические узлы не выявлены.",
          3,
        ),
      ],
    },
    {
      title: "Очаговые образования / узлы — EU-TIRADS", titleKey: "usi.lbl.ochagovye_obrazovaniya_uzly_eu_tirads",
      items: [
        note(
          "nodes_absent",
          "При отсутствии узлов: очаговые образования в паренхиме щитовидной железы не выявлены. Категория EU-TIRADS к отсутствующему узлу не применяется.",
          3,
        ),
      ],
    },
    { title: "Узел № 1", titleKey: "usi.lbl.uzel_1", items: thyroidNodeItems("node1") },
    { title: "Узел № 2", titleKey: "usi.lbl.uzel_2", items: thyroidNodeItems("node2") },
    {
      title: "Памятка по EU-TIRADS", titleKey: "usi.lbl.pamyatka_po_eu_tirads",
      items: [
        note(
          "tirads_memo",
          "EU-TIRADS 2 — доброкачественная категория: простая киста или полностью губчатый узел.\nEU-TIRADS 3 — низкий риск: овальный узел с ровными контурами, изо-/гиперэхогенный, без признаков высокого риска.\nEU-TIRADS 4 — промежуточный риск: овальный узел с ровными контурами, умеренно гипоэхогенный, без признаков высокого риска.\nEU-TIRADS 5 — высокий риск: наличие как минимум одного подозрительного признака — неправильная форма, неправильные контуры, микрокальцинаты или выраженная гипоэхогенность.\nРешение о тонкоигольной аспирационной биопсии принимается с учетом категории EU-TIRADS, максимального размера узла и клинического контекста.",
          6,
        ),
      ],
    },
    conclusion(
      "Ультразвуковых признаков структурных изменений щитовидной железы на момент исследования не выявлено. Паренхима однородная, эхогенность и васкуляризация не изменены. Очаговые образования не выявлены. Патологически измененные регионарные лимфатические узлы не определяются.",
    ),
  ],
};

const breastStandardSchema = {
  key: "breast_standard",
  label: "Гобечия И. А. - УЗИ молочных желез", labelKey: "usi.lbl.gobechiya_i_a_uzi_molochnyh_zhelez",
  title: "УЗИ молочных желез", titleKey: "usi.lbl.uzi_molochnyh_zhelez",
  heading: "УЗИ молочных желез", headingKey: "usi.lbl.uzi_molochnyh_zhelez",
  blocks: [
    {
      title: "Протокол", titleKey: "usi.lbl.protokol",
      items: [
        note(
          "protocol",
          "День менструального цикла:\nКожа без особенностей.\nОбласть сосков без особенностей.\nДифференциация тканей: хорошая\nВизуализация молочных протоков: хорошая\nСоотношение тканей: молочные железы в основном представлены железистой тканью.\nПротоки: протоки не расширены, состояние протоков соответствует фазе менструального цикла.\nВизуализация позадисосковой области: хорошая,\nДиффузные изменения: не выявляются,\n\nОчаговые образования:\nв правой железе: не выявлены\nв левой железе: не выявлены\n\nВизуализация структуры молочной железы: нарушения ультразвуковой архитектоники не выявлено.\nВизуализация передней и задней стенки МЖ: хорошая,\n\nОсмотрены лимфатические узлы парамаммарные, латеральные подмышечные лимфоузлы, центральные подмышечные лимфоузлы справа и слева - лимфоузлы в размерах и структуре не изменены.",
          14,
        ),
      ],
    },
    conclusion(
      "УЗ-признаков структурных изменений молочных желез не обнаружено.",
    ),
  ],
};

const thyroidParathyroidSchema = {
  key: "thyroid_parathyroid",
  label: "Гобечия И. А. - УЗИ щитовидной железы и паращитовидных желез", labelKey: "usi.lbl.gobechiya_i_a_uzi_schitovidnoy_zhelezy_i_paraschitovidnyh_zh",
  title: "УЗИ щитовидной железы и паращитовидных желез", titleKey: "usi.lbl.uzi_schitovidnoy_zhelezy_i_paraschitovidnyh_zhelez",
  heading: "УЗИ щитовидной железы и паращитовидных желез", headingKey: "usi.lbl.uzi_schitovidnoy_zhelezy_i_paraschitovidnyh_zhelez",
  blocks: [
    {
      title: "Протокол", titleKey: "usi.lbl.protokol",
      items: [
        note(
          "protocol",
          "Контур: ровный, четкий.\n\nПРАВАЯ ДОЛЯ:\nРазмер: не увеличен.\nДлина: 43 мм (N до 60х18х18).\nШирина: 12 мм.\nТолщина: 16 мм.\nСтруктура: однородная, мелкозернистого вида. Кровоток не усилен.\nЭхоплотность паренхимы: средняя.\n\nЛЕВАЯ ДОЛЯ:\nРазмер: не увеличен.\nДлина: 41 мм.\nШирина: 13 мм.\nТолщина: 15 мм.\nСтруктура: однородная, мелкозернистого вида. Кровоток не усилен.\nЭхоплотность паренхимы: средняя.\n\nПЕРЕШЕЕК: не утолщен, до 3 мм.\nОбъем правой доли: 4,3 см³.\nОбъем левой доли: 4,1 см³.\nОбщий объем щитовидной железы: 8,4 см³ (женщины норма 4,4–18 см³;\nбеременные — не более 20 см³; мужчины норма 7,7–25 см³).\nРегионарные лимфоузлы: надключичные, подключичные, шейные с обеих сторон — без особенностей.",
          16,
        ),
      ],
    },
    conclusion(
      "На момент исследования УЗ-признаков структурных изменений ткани щитовидной железы не обнаружено.",
    ),
  ],
};

const urinaryTractSchema = {
  key: "urinary_tract",
  label: "УЗИ мочевыделительной системы", labelKey: "usi.lbl.uzi_mochevydelitelnoy_sistemy",
  title: "УЗИ мочевыносящей системы", titleKey: "usi.lbl.uzi_mochevynosyaschey_sistemy",
  heading: "УЗИ мочевыносящей системы", headingKey: "usi.lbl.uzi_mochevynosyaschey_sistemy",
  blocks: [
    {
      title: "Протокол", titleKey: "usi.lbl.protokol",
      items: [
        note(
          "protocol",
          "Акустический доступ: затруднен, однако исследование возможно.\n\nПравая почка:\nРасположение: обычное.\nРазмеры и форма: не изменены.\nРазмеры: длина — мм, ширина — мм, толщина — мм.\nКонтуры: четкие, ровные.\nПаренхима: сохранена, эхогенность нормальная, толщина паренхимы: до 16 мм.\nЧашечно-лоханочная система: не расширена.\nКонкременты: не выявлены. Образования: не выявлены.\n\nЛевая почка:\nРасположение: обычное.\nРазмеры и форма: не изменены.\nРазмеры: длина — мм, ширина — мм, толщина — мм.\nКонтуры: четкие, ровные.\nПаренхима: сохранена, эхогенность нормальная, толщина паренхимы: до 14 мм.\nЧашечно-лоханочная система: не расширена.\nКонкременты: в паренхиме верхнего синуса гиперэхогенные сигналы до 3 мм, дающие акустическую тень.\nОбразования: не выявлены.\n\nНадпочечники: область надпочечников без видимых изменений.\nМочевой пузырь: наполнен удовлетворительно, содержит — мл.\nФорма: в поперечном срезе — овальная, в сагиттальном срезе — треугольная с закругленными углами, симметричная.\nКонтуры: ровные, четкие.\nСтенки: гладкие, не утолщены.\nШейка пузыря: визуализируется четко.\nПолость: анэхогенна, без дополнительных экзофитных образований.\nСодержимое пузыря: анэхогенное.\nОбъем мочевого пузыря: 108 мл.\nДистальный отдел мочеточника справа и слева: не расширен, без включений.\nЖидкость в ретровезикальном отделе: не определяется.\nПри ЦДК определяется адекватный выброс из устьев обоих мочеточников.\nОпорожняется: полностью.\nОбъем остаточной мочи: нет.",
          26,
        ),
      ],
    },
    conclusion("УЗ-признаки"),
  ],
};

const pelvisStandardSchema = {
  key: "pelvis_standard",
  label: "Гобечия И. А. - УЗИ органов малого таза", labelKey: "usi.lbl.gobechiya_i_a_uzi_organov_malogo_taza",
  title: "УЗИ органов малого таза", titleKey: "usi.lbl.uzi_organov_malogo_taza",
  heading: "УЗИ органов малого таза", headingKey: "usi.lbl.uzi_organov_malogo_taza",
  blocks: [
    {
      title: "Протокол", titleKey: "usi.lbl.protokol",
      items: [
        note(
          "protocol",
          "Акустический доступ: трансвагинальное исследование.\nДень менструального цикла: —\nВизуализация не затруднена.\nМатка в anteversio.\nРазмеры: длина — 47 мм, ширина — 30 мм, передне-задний — 50 мм.\nМиометрий однородный.\nЭндометрий: м-ЭХО = 3 мм.\n\nСПРАВА:\nЯичник: не увеличен.\nРасположение: типичное.\nРазмеры: длина — 26 мм, ширина — 20 мм, передне-задний — 22 мм.\nСтруктура: фолликулярная. В срезе до 5 фолликулов размерами 5–6 мм.\nОбъем яичника: 6 см³.\nТруба не визуализирована.\n\nСЛЕВА:\nЯичник: не увеличен.\nРасположение: типичное.\nРазмеры: длина — 25 мм, ширина — 20 мм, передне-задний — 21 мм.\nСтруктура: фолликулярная. В срезе до 5 фолликулов размерами 5–6 мм.\nОбъем яичника: 5 см³.\nТруба не визуализирована.\nЖидкость в позадиматочном пространстве: нет.",
          22,
        ),
      ],
    },
    conclusion(
      "УЗ-признаков структурных изменений органов малого таза не обнаружено. ORADS1\nКонсультация гинеколога.\nУЗ-заключение не является диагнозом, должно быть интерпретировано лечащим врачом.",
    ),
  ],
};

const lowerVeinsStandardSchema = {
  key: "lower_veins_standard",
  label: "Гобечия И. А. - УЗИ вен нижних конечностей", labelKey: "usi.lbl.gobechiya_i_a_uzi_ven_nizhnih_konechnostey",
  title: "УЗИ вен нижних конечностей", titleKey: "usi.lbl.uzi_ven_nizhnih_konechnostey",
  heading: "УЗИ вен нижних конечностей", headingKey: "usi.lbl.uzi_ven_nizhnih_konechnostey",
  blocks: [
    {
      title: "Протокол", titleKey: "usi.lbl.protokol",
      items: [
        note(
          "protocol",
          "ПРАВАЯ НИЖНЯЯ КОНЕЧНОСТЬ:\n\nОбщая бедренная вена: не расширена, просвет чист, при сдавливании спадается полностью.\nГлубокая бедренная вена: не расширена, просвет чист, при сдавливании спадается полностью.\nПоверхностная бедренная вена: не расширена, просвет чист, при сдавливании спадается полностью.\nПодколенная вена: не расширена, просвет чист, при сдавливании спадается полностью.\nПередние большеберцовые вены: не расширены, просвет чист, при сдавливании спадаются полностью.\nЗадние большеберцовые вены: не расширены, просвет чист, при сдавливании спадаются полностью.\nСуральные вены: не расширены, просвет чист, при сдавливании спадаются полностью.\nМалые большеберцовые вены: не расширены, просвет чист, при сдавливании спадаются полностью.\nБольшая подкожная вена: не расширена, просвет чист, при сдавливании спадается полностью. Остиальный клапан состоятелен. Сафено-феморальное соустье — 6 мм, сафено-поплитеальное соустье — 5,5 мм.\nМалая подкожная вена: не расширена, просвет чист, при сдавливании спадается полностью.\nКлапанная недостаточность перфорантных вен голени: нет.\n\nЛЕВАЯ НИЖНЯЯ КОНЕЧНОСТЬ:\n\nОбщая бедренная вена: не расширена, просвет чист, при сдавливании спадается полностью.\nГлубокая бедренная вена: не расширена, просвет чист, при сдавливании спадается полностью.\nПоверхностная бедренная вена: не расширена, просвет чист, при сдавливании спадается полностью.\nПодколенная вена: не расширена, просвет чист, при сдавливании спадается полностью.\nПередние большеберцовые вены: не расширены, просвет чист, при сдавливании спадаются полностью.\nЗадние большеберцовые вены: не расширены, просвет чист, при сдавливании спадаются полностью.\nСуральные вены: не расширены, просвет чист, при сдавливании спадаются полностью.\nМалые большеберцовые вены: не расширены, просвет чист, при сдавливании спадаются полностью.\nБольшая подкожная вена: не расширена, просвет чист, при сдавливании спадается полностью. Остиальный клапан состоятелен. Сафено-феморальное соустье — 6 мм, сафено-поплитеальное соустье — 5,5 мм.\nМалая подкожная вена: не расширена, просвет чист, при сдавливании спадается полностью.\nКлапанная недостаточность перфорантных вен голени: нет.",
          30,
        ),
      ],
    },
    conclusion(
      "Глубокие и поверхностные вены проходимы, клапаны глубоких и поверхностных вен состоятельны, внутрипросветных образований нет.",
    ),
    {
      title: "Рекомендации", titleKey: "usi.lbl.rekomendacii",
      items: [note("recommendations", "консультация лечащего врача.", 3)],
    },
  ],
};

const abdomenRetroperitoneumSchema = {
  key: "abdomen_retroperitoneum",
  label:
    "Гобечия И. А. - УЗИ органов брюшной полости и забрюшинного пространства",
  title: "УЗИ органов брюшной полости и забрюшинного пространства", titleKey: "usi.lbl.uzi_organov_bryushnoy_polosti_i_zabryushinnogo_prostranstva",
  heading: "УЗИ органов брюшной полости и забрюшинного пространства", headingKey: "usi.lbl.uzi_organov_bryushnoy_polosti_i_zabryushinnogo_prostranstva",
  blocks: [
    {
      title: "Протокол", titleKey: "usi.lbl.protokol",
      items: [
        note(
          "protocol",
          "Печень:\nРасположение: в правом подреберье, с ровным контуром.\nРазмеры: вертикальный размер правой доли — 141 мм (норма до 150 мм), толщина правой доли — 120 мм (норма до 125 мм), толщина левой доли — 56 мм (норма до 70 мм), кранио-каудальный размер левой доли — 90 мм (норма до 100 мм).\nЭхогенность: повышенная.\nСтруктура паренхимы: умеренно диффузно-неоднородная.\nСосудистый рисунок: сохранен.\nВоротная вена в воротах печени: диаметр до 11 мм (N 10–14 мм).\nОбъемные образования: не выявлены.\n\nЖелчный пузырь:\nРасположение и форма: типичное.\nРазмеры: длинник — 70 мм, поперечник — 20 мм, контуры ровные, четкие.\nСтенка не утолщена, до 2,7 мм (N 3 мм).\nПолость: содержимое гомогенно.\nХоледох: не расширен, на видимых участках проходим.\nОбразования: не выявлены.\n\nПоджелудочная железа:\nРасположение: обычное.\nКонтуры: четкие, не ровные.\nРазмеры: не изменены; головка — 25 мм (норма до 32 мм), тело — 20 мм (норма до 20), хвост — 21 мм (норма до 30).\nСтруктура паренхимы: диффузно-неоднородная.\nЭхогенность: средней эхогенности.\nВирсунгов проток не дифференцируется.\nОбразования: не выявлены.\n\nСелезенка:\nРасположение и контуры: обычное, контуры ровные, четкие.\nРазмеры и форма: не увеличена; длинник — 82 мм, толщина — 50 мм, площадь — 30 см².\nСтруктура паренхимы: однородная, сопоставима с корковым веществом почки.\nСелезеночная вена, воротная вена, нижняя полая вена и аорта имеют обычный диаметр, стенки их не утолщены.\n\nПравая почка:\nРасположение: обычное.\nРазмеры и форма: не изменены.\nРазмеры: длина — 110 мм, ширина — 55 мм, толщина — 48 мм.\nКонтуры: не четкие, ровные.\nПаренхима: сохранена, эхогенность нормальная, толщина паренхимы — 21 мм.\nЧашечно-лоханочная система: не расширена.\nКонкременты: не выявлены.\nОбразования: не выявлены.\n\nЛевая почка:\nРасположение: обычное.\nРазмеры и форма: не изменены.\nРазмеры: длина — 106 мм, ширина — 56 мм, толщина — 50 мм.\nКонтуры: не четкие, ровные.\nПаренхима: сохранена, эхогенность нормальная, толщина паренхимы — 20 мм.\nЧашечно-лоханочная система: не расширена.\nКонкременты: не выявлены.\nОбразования: не выявлены.\n\nНадпочечники: область надпочечников без видимых изменений.\nМочеточники в видимых участках не расширены, без дополнительных акустических сигналов.",
          40,
        ),
      ],
    },
    conclusion(""),
  ],
};

const abdomenOnlySchema = {
  key: "abdomen_gobeciya",
  label: "Гобечия И. А. - УЗИ органов брюшной полости", labelKey: "usi.lbl.gobechiya_i_a_uzi_organov_bryushnoy_polosti",
  title: "УЗИ органов брюшной полости", titleKey: "usi.lbl.uzi_organov_bryushnoy_polosti",
  heading: "УЗИ органов брюшной полости", headingKey: "usi.lbl.uzi_organov_bryushnoy_polosti",
  blocks: [
    {
      title: "Протокол", titleKey: "usi.lbl.protokol",
      items: [
        note(
          "protocol",
          "Печень:\nРасположение: в правом подреберье, с ровным контуром.\nРазмеры: вертикальный размер правой доли — 141 мм (норма до 150 мм), толщина правой доли — 120 мм (норма до 125 мм), толщина левой доли — 56 мм (норма до 70 мм), кранио-каудальный размер левой доли — 90 мм (норма до 100 мм).\nЭхогенность: повышенная.\nСтруктура паренхимы: умеренно диффузно-неоднородная.\nСосудистый рисунок: сохранен.\nВоротная вена в воротах печени: диаметр до 11 мм (N 10–14 мм).\nОбъемные образования: не выявлены.\n\nЖелчный пузырь:\nРасположение и форма: типичное.\nРазмеры: длинник — 70 мм, поперечник — 20 мм, контуры ровные, четкие.\nСтенка не утолщена, до 2,7 мм (N 3 мм).\nПолость: содержимое гомогенно.\nХоледох: не расширен, на видимых участках проходим.\nОбразования: не выявлены.\n\nПоджелудочная железа:\nРасположение: обычное.\nКонтуры: четкие, не ровные.\nРазмеры: не изменены; головка — 25 мм (норма до 32 мм), тело — 20 мм (норма до 20), хвост — 21 мм (норма до 30).\nСтруктура паренхимы: диффузно-неоднородная.\nЭхогенность: средней эхогенности.\nВирсунгов проток не дифференцируется.\nОбразования: не выявлены.\n\nСелезенка:\nРасположение и контуры: обычное, контуры ровные, четкие.\nРазмеры и форма: не увеличена; длинник — 82 мм, толщина — 50 мм, площадь — 30 см².\nСтруктура паренхимы: однородная, сопоставима с корковым веществом почки.\nСелезеночная вена, воротная вена, нижняя полая вена и аорта имеют обычный диаметр, стенки их не утолщены.",
          40,
        ),
      ],
    },
    conclusion(""),
  ],
};

const bcaStandardSchema = {
  key: "bca_standard",
  label: "Гобечия И. А. - УЗИ брахиоцефальных артерий", labelKey: "usi.lbl.gobechiya_i_a_uzi_brahiocefalnyh_arteriy",
  title: "УЗИ брахиоцефальных артерий", titleKey: "usi.lbl.uzi_brahiocefalnyh_arteriy",
  heading: "УЗИ брахиоцефальных артерий", headingKey: "usi.lbl.uzi_brahiocefalnyh_arteriy",
  blocks: [
    {
      title: "Протокол", titleKey: "usi.lbl.protokol",
      items: [
        note(
          "protocol",
          "Общая сонная артерия справа:\nЛС, см/с — 56,3 (N 50–104).\nДС, см/с — 11,1 (N 3–36).\nИС — 0,80 (N 0,6–0,9).\nПросвет артерии, см — 0,8.\nКИМ, см — 0,06, дифференцировка на слои сохранена.\nТип кровотока — ламинарный.\nГемодинамически значимые изменения — не выявлено.\nИсследование ВСА и НСА — гемодинамически значимых отклонений не выявлено.\n\nОбщая сонная артерия слева:\nЛС, см/с — 82,1 (N 50–104).\nДС, см/с — 17,6 (N 3–36).\nИС — 0,79 (N 0,6–0,9).\nПросвет артерии, см — 0,7.\nКИМ, см — 0,06, дифференцировка на слои сохранена.\nТип кровотока — ламинарный.\nГемодинамически значимые изменения — не выявлены.\nИсследование ВСА и НСА — гемодинамически значимых отклонений не выявлено.\n\nПозвоночная артерия справа:\nВизуализация на всем протяжении.\nЛС, см/с — 56,2 (N 20–61).\nДС, см/с — 17,4 (N 6–27).\nИС — 0,70 (N 0,5–0,8).\nПросвет артерии, см — 0,5.\nТип кровотока — ламинарный.\nГемодинамически значимые изменения — не выявлено.\n\nПозвоночная артерия слева:\nВизуализация на всем протяжении.\nЛС, см/с — 41,4 (N 20–61).\nДС, см/с — 13,6 (N 6–27).\nИС — 0,60 (N 0,5–0,8).\nПросвет артерии, см — 0,5.\nТип кровотока — ламинарный.\nГемодинамически значимые изменения — не выявлено.\n\nПодключичная артерия справа:\nПроходимость — визуализация на всем протяжении.\nСкоростные показатели кровотока: не снижены.\nИндексы периферического сопротивления в парных сегментах: не изменены.\nСкорости — в диапазоне нормативных величин.\nПериферическое сопротивление — в пределах возрастной нормы.\n\nПодключичная артерия слева:\nПроходимость — визуализация на всем протяжении.\nСкоростные показатели кровотока: не снижены.\nИндексы периферического сопротивления в парных сегментах: не изменены.\nСкорости — в диапазоне нормативных величин.\nПериферическое сопротивление — в пределах возрастной нормы.",
          40,
        ),
      ],
    },
    conclusion(
      "Деформаций анатомического хода внечерепных отделов брахиоцефальных артерий на момент осмотра не выявлено.\nЭХО-признаков атеросклероза сонных, позвоночных и подключичных артерий на момент исследования не выявлено. Скоростные показатели кровотока в пределах возрастной нормы.",
    ),
    {
      title: "Рекомендации", titleKey: "usi.lbl.rekomendacii",
      items: [note("recommendations", "консультация кардиолога.", 3)],
    },
  ],
};

export const extraUsiSchemas = [
  duplexAortaSchema,
  duplexBcaSchema,
  duplexUpperVeinsSchema,
  duplexLowerVeinsSchema,
  duplexRenalSchema,
  urinaryComplexSchema,
  abdomenSchema,
  kidneysAdrenalsSchema,
  trusProstateSchema,
  breastBiradsSchema,
  pelvisFemaleSchema,
  scrotumSchema,
  liverBiliarySchema,
  lymphNodesSchema,
  prostateTaSchema,
  jointsSchema,
  thyroidSchema,
  breastStandardSchema,
  thyroidParathyroidSchema,
  urinaryTractSchema,
  pelvisStandardSchema,
  lowerVeinsStandardSchema,
  abdomenRetroperitoneumSchema,
  abdomenOnlySchema,
  bcaStandardSchema,
];
